import React, { useState, useRef, useEffect } from 'react';
import { Search, ChevronUp, Volume2, VolumeX, TrendingUp, Phone, Save, FileText, Brain, Download, Copy, X, Clock, User, MessageSquare } from 'lucide-react';
import "./alex.css"
import { signOut } from 'firebase/auth';
import { auth } from '../../../firebase/firebase';
import { EVIWebAudioPlayer } from 'hume';
import FirebaseConfigService from './services/FirebaseConfigService';

import JournalStorageService from './services/JournalStorageService';
import { useNavigate } from 'react-router-dom';
import ReminderService from './services/ReminderService';
import { ReminderSetModal, ReminderTriggeredModal, ReminderTabContent } from './components/ReminderComponents';


import VoiceSelectionModal from './components/VoiceSelectionModal';
import VoicePreferenceService from './services/VoicePreferenceService';
import './components/VoiceSelectionModal.css';
// At the top of your main React component file
import CallTimerService from './services/CallTimerService';

// Import the separated services
import DataStoreService from './services/DataStoreService';
import AzureOpenAIService from './services/AzureOpenAIService';
import ExportService from './services/ExportService';
import AudioService from './services/AudioService';
import GlassNavigation from './components/GlassNavigation';
import FeedbackPopup from './FeedbackPopup'; 

// 🔥 NEW: Replace localStorage service with Firestore
import FirestorePersistentStorageService from './services/FirestorePersistentStorageService';

import FirstTimeUserGuide from './components/FirstTimeUserGuide';
import FirstTimeUserService from './services/FirstTimeUserService';
import './components/FirstTimeUserGuide.css';
import UserInfoTabContent from './UserInfoTabContent';
import ThreeNavGlass from './components/ThreeNavGlass';

const HumeEVIInterface = () => {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
const [hasShownFeedbackOnce, setHasShownFeedbackOnce] = useState(false);
const [feedbackSkipCount, setFeedbackSkipCount] = useState(0);
const [feedbackCompleted, setFeedbackCompleted] = useState(false);

  //tracking initial page load
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  //firebase api state loading
  const [apiConfig, setApiConfig] = useState(null);
  const [configLoaded, setConfigLoaded] = useState(false); // NEW: Track config loading
  
  //Journal storage
  const navigate = useNavigate();
  //set preptune id to be visible or not
  const [isIdVisible, setIsIdVisible] = useState(false);
  // when preptune id is copied
  const [copied, setCopied] = useState(false);

  const [journalStorageService] = useState(() => new JournalStorageService());
  const [isSaving, setIsSaving] = useState(false);
  const [showViewJournalButton, setShowViewJournalButton] = useState(false);

const [showVoiceSelection, setShowVoiceSelection] = useState(false);
const [isFirstTimeUser, setIsFirstTimeUser] = useState(false);
const [isAppReady, setIsAppReady] = useState(true); // Changed from false to true
const [userFlow, setUserFlow] = useState('loading'); // 'loading' | 'returning' | 'new' | 'error'

// 🔥 FIX 2: Add a loading state to control when to show UI elements
const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

  // NEW: First-time user guide states
const [firstTimeService] = useState(() => new FirstTimeUserService());
const [showFirstTimeGuide, setShowFirstTimeGuide] = useState(false);
const [hasCompletedGuide, setHasCompletedGuide] = useState(false);

  // Service instances
  const dataStoreService = useRef(new DataStoreService());
  const azureOpenAIService = useRef(null);
  // NEW: Voice selection states
const [voicePreferenceService] = useState(() => new VoicePreferenceService());
const [currentVoice, setCurrentVoice] = useState(null);

  // 🔥 NEW: Firestore persistent storage service
  const [firestoreStorage] = useState(() => new FirestorePersistentStorageService());
  const [persistentUserId, setPersistentUserId] = useState(null);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [sessionStats, setSessionStats] = useState(null);
  const [isStorageInitialized, setIsStorageInitialized] = useState(false);
  
  // Session timeout and activity tracking
  const sessionTimeoutRef = useRef(null);
  const activityTimeoutRef = useRef(null);
  
  // Hume EVI refs
  const wsRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);
  const playerRef = useRef(null);

  // Configuration - only access after config is loaded
  const HUME_API_KEY = configLoaded ? apiConfig?.HUME_API_KEY : null;
  const AZURE_OPENAI_ENDPOINT = configLoaded ? apiConfig?.AZURE_OPENAI_ENDPOINT : null;
  const AZURE_OPENAI_API_KEY = configLoaded ? apiConfig?.AZURE_OPENAI_API_KEY : null;
  const AZURE_OPENAI_DEPLOYMENT = configLoaded ? apiConfig?.AZURE_OPENAI_DEPLOYMENT : null;
  const EVI_WS_URL = configLoaded ? (apiConfig?.EVI_WS_URL || 'wss://api.hume.ai/v0/evi/chat') : null;
  const CONFIG_ID = currentVoice?.configId || voicePreferenceService.getCurrentConfigId();


  // Hume EVI states
  const [isConnected, setIsConnected] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('disconnected');
  const [error, setError] = useState('');
  const [conversation, setConversation] = useState([]);
  const [currentEmotion, setCurrentEmotion] = useState('');
  const [isEviSpeaking, setIsEviSpeaking] = useState(false);
  
  // Enhanced AI services states
  const [conversationSummary, setConversationSummary] = useState('');
  const [emotionalInsights, setEmotionalInsights] = useState('');
  const [isGeneratingSummary, setIsGeneratingSummary] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  // New resume chat states
  const [chatGroupId, setChatGroupId] = useState(null);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [isResumingChat, setIsResumingChat] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  
  // New summary queue states
  const [sessionActive, setSessionActive] = useState(false);
  const [sessionStartTime, setSessionStartTime] = useState(null);
  const [lastActivity, setLastActivity] = useState(null);
  const [autoSummaryPending, setAutoSummaryPending] = useState(false);

  // UI states from your design
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [showSummary, setShowSummary] = useState(false);
  const [activeTab, setActiveTab] = useState('Listen');
  const [watchingThreads, setWatchingThreads] = useState(0);
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');
  const [showResponse, setShowResponse] = useState(false);

  const [currentChatGroupId, setCurrentChatGroupId] = useState(null);
  const [latestChatGroup, setLatestChatGroup] = useState(null);
  const [isResuming, setIsResuming] = useState(false);
  const [contextInjected, setContextInjected] = useState(false);

  // Enhanced state management for multiple audio types
  const [startupSoundPlaying, setStartupSoundPlaying] = useState(false);
  const [preResponseSoundPlaying, setPreResponseSoundPlaying] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);

  // Timer states
const [timeRemaining, setTimeRemaining] = useState(1200); // Changed from 300 to 1200 (20 minutes in seconds)
  const [callEnded, setCallEnded] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);
  const timerRef = useRef(null);

  const [callTimerService] = useState(() => new CallTimerService(firestoreStorage));
const [persistentTimeRemaining, setPersistentTimeRemaining] = useState(1200); // Changed from 300 to 1200
const [timerInitialized, setTimerInitialized] = useState(false);

  // Summary header states
  const [summaryHeader, setSummaryHeader] = useState('');
  const [displayedHeader, setDisplayedHeader] = useState('');

  // Display and animation states
  const [displayedSummary, setDisplayedSummary] = useState('');
  const [displayedInsights, setDisplayedInsights] = useState('');
  const [typingTimeouts, setTypingTimeouts] = useState([]);
  const [emmaLoadingPhase, setEmmaLoadingPhase] = useState('initial');
  const [emmaLoadingProgress, setEmmaLoadingProgress] = useState(0);
  const [journalRequested, setJournalRequested] = useState(false);
  const [takingNoteMessage, setTakingNoteMessage] = useState(false);
  const [journalButtonClicked, setJournalButtonClicked] = useState(false);
  
  // NEW: Reminder system states
  const [reminderService] = useState(() => new ReminderService());
  const [activeReminders, setActiveReminders] = useState([]);
  const [showReminderSetModal, setShowReminderSetModal] = useState(false);
  const [showReminderTriggeredModal, setShowReminderTriggeredModal] = useState(false);
  const [currentReminder, setCurrentReminder] = useState(null);
  const [reminderRequested, setReminderRequested] = useState(false);
  const [isManuallySaved, setIsManuallySaved] = useState(false);
const [activeModal, setActiveModal] = useState(null); // Track which modal is currently open
const [showMicPermissionDialog, setShowMicPermissionDialog] = useState(false);
const [micPermissionGranted, setMicPermissionGranted] = useState(false);

const [micPermissionChecked, setMicPermissionChecked] = useState(false);

const [permissionCache, setPermissionCache] = useState(() => {
  try {
    const cached = sessionStorage.getItem('preptune-mic-permission');
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
});
useEffect(() => {
  const checkCachedPermission = async () => {
    if (permissionCache?.granted && permissionCache?.timestamp) {
      const cacheAge = Date.now() - permissionCache.timestamp;
      const maxAge = 30 * 60 * 1000; // 30 minutes
      
      if (cacheAge < maxAge) {
        console.log('Using cached microphone permission');
        setMicPermissionGranted(true);
        setMicPermissionChecked(true);
        return;
      }
    }
    
    // Try permission API first (non-intrusive)
    try {
      if ('permissions' in navigator) {
        const permission = await navigator.permissions.query({ name: 'microphone' });
        if (permission.state === 'granted') {
          console.log('Microphone permission already granted via Permissions API');
          setMicPermissionGranted(true);
          setMicPermissionChecked(true);
          
          // Cache the permission
          const cacheData = { granted: true, timestamp: Date.now() };
          sessionStorage.setItem('preptune-mic-permission', JSON.stringify(cacheData));
          setPermissionCache(cacheData);
          return;
        }
      }
    } catch (error) {
      console.log('Permissions API check failed, will check on user action');
    }
    
    setMicPermissionChecked(true);
  };
  
  checkCachedPermission();
}, []);
// Simple permission check on app load
const checkMicrophoneAccess = async () => {
  try {
    console.log('Testing microphone access...');
    
    // For users with recent cached permission, do a lighter check first
    if (permissionCache?.granted && permissionCache?.timestamp) {
      const cacheAge = Date.now() - permissionCache.timestamp;
      if (cacheAge < 5 * 60 * 1000) { // 5 minutes
        try {
          // Quick permission API check (non-intrusive)
          if ('permissions' in navigator) {
            const permission = await navigator.permissions.query({ name: 'microphone' });
            if (permission.state === 'granted') {
              console.log('Microphone still granted via Permissions API');
              return true;
            }
          }
        } catch (error) {
          console.log('Permissions API failed, falling back to stream test');
        }
      }
    }
    
    // Full stream test for new users or when cache is stale
    const stream = await navigator.mediaDevices.getUserMedia({ 
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
        sampleRate: 44100,
        channelCount: 1
      } 
    });
    
    console.log('Microphone stream obtained successfully');
    
    // Keep stream alive briefly for iOS compatibility
    setTimeout(() => {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }, 100);
    
    return true;
    
  } catch (error) {
    console.log('Microphone access check failed:', error.name, error.message);
    
    // Clear invalid cache
    if (error.name === 'NotAllowedError') {
      try {
        sessionStorage.removeItem('preptune-mic-permission');
        setPermissionCache(null);
      } catch {}
    }
    
    return false;
  }
};

// Modified startListening - show dialog if no permission
const startListening = async () => {
  // Existing timer validation
  if (isTimerExpired()) {
    showTrialExceededError();
    setCallEnded(true);
    return;
  }
  
  // Existing voice validation
  if (!currentVoice || !currentVoice.configId) {
    setError('Please select a voice companion first');
    return;
  }

  // Existing setup validation
  if (showVoiceSelection || showFirstTimeGuide) {
    setError('Please complete setup first');
    return;
  }
  
  console.log('🎙️ Starting listening process...');
  
  // Always check microphone access on user interaction (iOS requirement)
  const hasAccess = await checkMicrophoneAccess();
  
  if (!hasAccess) {
    console.log('🚫 No microphone access, showing permission dialog');
    setShowMicPermissionDialog(true);
    return;
  }
  
  console.log('✅ Microphone access confirmed, proceeding with call');
  setMicPermissionGranted(true);
  
  // Proceed with EVI call
  proceedWithEVICall();
};

// Handle user's permission choice
const handleMicPermissionResponse = async (userSaidYes) => {
  setShowMicPermissionDialog(false);
  
  if (!userSaidYes) {
    setError('Microphone access is required for voice conversations with Preptune');
    return;
  }
  
  console.log('🎤 User agreed to microphone access, requesting permission...');
  
  try {
    // iOS-compatible media stream request with comprehensive settings
    const stream = await navigator.mediaDevices.getUserMedia({ 
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
        sampleRate: 44100,
        channelCount: 1,
        // iOS-specific Chrome settings (ignored by Safari)
        googEchoCancellation: true,
        googAutoGainControl: true,
        googNoiseSuppression: true,
        googHighpassFilter: true
      } 
    });
    
    console.log('✅ Microphone permission granted successfully');
    
    // Cache the successful permission
    const cacheData = { granted: true, timestamp: Date.now() };
    try {
      sessionStorage.setItem('preptune-mic-permission', JSON.stringify(cacheData));
      setPermissionCache(cacheData);
    } catch (error) {
      console.log('Could not cache permission:', error);
    }
    
    setMicPermissionGranted(true);
    console.log('📊 Stream details:', {
      active: stream.active,
      tracks: stream.getTracks().length,
      trackStates: stream.getTracks().map(t => t.readyState)
    });
    
    // Keep stream alive longer for iOS - helps with subsequent connections
    setTimeout(() => {
      stream.getTracks().forEach(track => {
        console.log('🛑 Stopping initial permission stream:', track.kind);
        track.stop();
      });
    }, 500);
    
    setMicPermissionGranted(true);
    
    // Small delay before proceeding helps iOS
    setTimeout(() => {
      console.log('🚀 Starting EVI call after permission granted');
      proceedWithEVICall();
    }, 200);
    
  } catch (error) {
    console.error('❌ Microphone permission error:', error);
    
    let errorMessage = 'Unable to access microphone. ';
    
    switch (error.name) {
      case 'NotAllowedError':
        errorMessage += 'Please allow microphone access in your browser and try again.';
        break;
      case 'NotFoundError':
        errorMessage += 'No microphone detected. Please check your device.';
        break;
      case 'NotSupportedError':
        errorMessage += 'Microphone not supported in this browser.';
        break;
      case 'NotReadableError':
        errorMessage += 'Microphone is being used by another application.';
        break;
      case 'SecurityError':
        errorMessage += 'Microphone access blocked due to security settings.';
        break;
      default:
        errorMessage += `${error.message || 'Unknown error occurred'}`;
    }
    
    setError(errorMessage);
    
    // Additional iOS guidance
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      setTimeout(() => {
        setError(errorMessage + ' On iOS, ensure Safari has microphone permission in Settings > Safari > Camera & Microphone.');
      }, 3000);
    }
  }
};



// Extract your EVI logic into this function (keep all your existing code)
const proceedWithEVICall = async () => {
  console.log('🎙️ Starting EVI call with confirmed microphone access');
  
  try {
    // Track first call completion
    if (isStorageInitialized && firestoreStorage.currentUser) {
      try {
        const userData = await firestoreStorage.getUserData();
        if (!userData.stats?.firstCallCompleted) {
          console.log('📊 Tracking first call completion');
          await firestoreStorage.updateUserData({
            'stats.firstCallCompleted': true,
            'stats.lastCallTime': new Date()
          });
          firstTimeService.markFirstCallCompleted();
          firstTimeService.updateLastCallTime();
          firstTimeService.trackMilestone('first-call-completed');
        }
      } catch (error) {
        console.error('Failed to track first call:', error);
      }
    }
    
    // Check WebSocket connection status
    const wsIsConnected = wsRef.current && wsRef.current.readyState === WebSocket.OPEN;
    console.log('🔗 WebSocket status:', wsIsConnected ? 'Connected' : 'Not connected');
    
    if (!wsIsConnected) {
      if (currentChatGroupId) {
        console.log('🔄 Resuming session with ID:', currentChatGroupId);
        await connectToEVI(currentChatGroupId, false);
      } else {
        console.log('🆕 Starting fresh session');
        await connectToEVI(null, false);
      }
    } else {
      console.log('📞 WebSocket already connected, starting recording');
      if (!isRecording) {
        await startRecording();
      }
    }
    
    setActiveTab('Listen');
    console.log('✅ EVI call setup completed');
    
  } catch (error) {
    console.error('❌ EVI call failed:', error);
    setError(`Failed to start voice conversation: ${error.message}. Please try again.`);
  }
};

  useEffect(() => {
    const loadAPIConfig = async () => {
      try {
        setIsInitialLoading(true);
        const config = await FirebaseConfigService.getConfig();
        if (config) {
          setApiConfig(config);
          setConfigLoaded(true);
        } else {
          setError('Failed to load API configuration');
        }
      } catch (err) {
        console.error('Config loading error:', err);
        setError('Failed to load API configuration');
      } finally {
        setIsInitialLoading(false);
      }
    };
    loadAPIConfig();
  }, []);

// 🔥 FIXED: Initialize persistent timer with better logic
useEffect(() => {
  const initializePersistentTimer = async () => {
    if (!isStorageInitialized || !firestoreStorage.currentUser || timerInitialized) return;
    
    try {
      console.log('⏰ Setting up persistent call timer...');
      
      callTimerService.setTimerUpdateCallback((remainingTime) => {
        setPersistentTimeRemaining(remainingTime);
        setTimeRemaining(remainingTime);
        
        // CRITICAL: Auto-prevent actions when timer hits 0
        if (remainingTime <= 0) {
          setCallEnded(true);
          // Stop any active recording
          if (isRecording) {
            stopRecording();
          }
          // Close WebSocket if connected
          if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.close(1000, 'Trial time exceeded');
          }
        }
      });
      
      callTimerService.setTimerExpiredCallback(() => {
        console.log('⏰ Timer expired callback - complete shutdown initiated');
        
        // Set all expired states first
        setCallEnded(true);
        setPersistentTimeRemaining(0);
        setTimeRemaining(0);
        
        // Force stop all recording immediately
        if (mediaRecorderRef.current) {
          try {
            if (mediaRecorderRef.current.state !== 'inactive') {
              mediaRecorderRef.current.stop();
            }
          } catch (error) {
            console.log('MediaRecorder already stopped:', error);
          }
          mediaRecorderRef.current = null;
        }
        
        // Force close microphone stream
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(track => {
            track.stop();
          });
          streamRef.current = null;
        }
        
        // Force close WebSocket
        if (wsRef.current) {
          try {
            if (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING) {
              wsRef.current.close(1000, 'Trial expired - forced shutdown');
            }
          } catch (error) {
            console.log('WebSocket already closed:', error);
          }
          wsRef.current = null;
        }
        
        // Reset all states
        setIsRecording(false);
        setIsConnected(false);
        setConnectionStatus('disconnected');
        setIsEviSpeaking(false);
        setIsPlaying(false);
        setIsInitializing(false);
        
        // Show error after cleanup
        showTrialExceededError();
        
        // End session
        endSession(true);
        
        console.log('🛑 Complete system shutdown due to timer expiration');
      });
      
      const timerState = await callTimerService.initializeTimer();
      
      // Enhanced timer state logic
      if (timerState.remainingTime <= 0 && !sessionActive && !isConnected) {
        // For inactive users with expired timer, show trial exceeded message
        console.log('⏰ Timer expired for returning user');
        setCallEnded(true);
        setPersistentTimeRemaining(0);
        setTimeRemaining(0);
        // Don't reset timer automatically - user must refresh for new trial
      } else {
        setPersistentTimeRemaining(timerState.remainingTime);
        setTimeRemaining(timerState.remainingTime);
        if (timerState.remainingTime <= 0) {
          setCallEnded(true);
        }
      }
      
      setTimerInitialized(true);
      
      console.log('✅ Persistent timer initialized:', {
        remainingTime: timerState.remainingTime,
        wasActive: timerState.isActive,
        callEnded: timerState.remainingTime <= 0
      });
      
} catch (error) {
  console.error('❌ Failed to setup persistent timer:', error);
  setPersistentTimeRemaining(1200); // Changed from 300 to 1200
  setTimeRemaining(1200); // Changed from 300 to 1200
  setTimerInitialized(true);
}
  };

  initializePersistentTimer();
}, [isStorageInitialized, firestoreStorage.currentUser]);
const closeAllModals = () => {
  setShowSummary(false);
  setShowFirstTimeGuide(false);
  setShowVoiceSelection(false);
  setShowReminderSetModal(false);
  setShowReminderTriggeredModal(false);
  setShowFeedbackPopup(false);
  setActiveModal(null);
};
// 🔥 FIXED: Sign out handler to completely clear state and localStorage
const handleSignOut = async () => {
  try {
    console.log('🚪 Signing out...');
    
    // 🔥 IMMEDIATELY set states to prevent flash
    setIsAppReady(false);
    setUserFlow('loading');
    setShowVoiceSelection(false);
    setIsFirstTimeUser(false);
    setShowFirstTimeGuide(false);
    setHasCompletedGuide(false);
    
    // Clear all other state
    setCurrentVoice(null);
    setConversation([]);
    setCurrentChatGroupId(null);
    setCurrentChatId(null);
    setPersistentUserId(null);
    setIsStorageInitialized(false);
    setConversationSummary('');
    setEmotionalInsights('');
    setSummaryHeader('');
    
    // Clear localStorage
    const keysToRemove = [
      'hume-evi-persistent-data',
      'hume-evi-conversations', 
      'voice-journal-entries',
      'preptune-voice-preference'
    ];

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });

    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('hume-conversation-') || key.startsWith('preptune-')) {
        localStorage.removeItem(key);
      }
    });
    
    // Sign out of Firebase
    await signOut(auth);
    
    console.log('✅ Signed out successfully');
    
    // Navigate to home
    window.location.href = '/';
    
  } catch (error) {
    console.error('❌ Sign out error:', error);
    setError('Sign out failed. Please try again.');
    setTimeout(() => setError(''), 3000);
    setIsAppReady(true); // Restore UI on error
  }
};
const LoadingScreen = ({ currentVoice }) => {

  return (
     <div className="admin-loading-screen">
        <div className="admin-loading-spinner"></div>
      </div>
  );
};
useEffect(() => {
  const loadFeedbackStatus = async () => {
    if (!isStorageInitialized || !firestoreStorage.currentUser) return;
    
    try {
      const userData = await firestoreStorage.getUserData();
      
      setFeedbackCompleted(userData.feedback?.completed || false);
      setFeedbackSkipCount(userData.feedback?.skipCount || 0);
      setHasShownFeedbackOnce(userData.feedback?.hasShownOnce || false);
      
    } catch (error) {
      console.error('Failed to load feedback status:', error);
    }
  };

  loadFeedbackStatus();
}, [isStorageInitialized, firestoreStorage.currentUser]);
const checkShouldShowFeedback = async () => {
  try {
    if (feedbackCompleted) return false;
    if (showFirstTimeGuide || isFirstTimeUser || showVoiceSelection) return false;
    if (conversation.length < 3) return false;
    if (!hasShownFeedbackOnce) return true;
    if (feedbackSkipCount === 1 && !hasShownFeedbackOnce) return true;
    if (feedbackSkipCount >= 2) return false;
    return false;
  } catch (error) {
    console.error('Error checking feedback conditions:', error);
    return false;
  }
};
const handleFeedbackSubmit = async (feedbackData) => {
  try {
    if (isStorageInitialized && firestoreStorage.currentUser) {
      const feedbackEntry = {
        ...feedbackData,
        userId: persistentUserId,
        voiceName: currentVoice?.name,
        sessionId: currentSessionId,
        submittedAt: new Date().toISOString(),
        conversationLength: conversation.length,
        sessionDuration: sessionStartTime ? Date.now() - sessionStartTime.getTime() : 0
      };

      await firestoreStorage.updateUserData({
        'feedback.completed': true,
        'feedback.lastSubmittedAt': new Date().toISOString(),
        'feedback.hasShownOnce': true
      });

      await firestoreStorage.saveFeedback(feedbackEntry);
      
      setFeedbackCompleted(true);
      setShowFeedbackPopup(false);
      
      setSuccessMessage('Thank you for your feedback! It helps us improve Preptune.');
      setTimeout(() => setSuccessMessage(''), 4000);
      
      // Restore what was open before feedback
      restorePreviousModalState();
    }
  } catch (error) {
    console.error('Failed to submit feedback:', error);
    setError('Failed to submit feedback. Please try again.');
    setTimeout(() => setError(''), 3000);
    
    // Still restore previous state and close feedback
    setShowFeedbackPopup(false);
    restorePreviousModalState();
  }
};

const handleFeedbackSkip = async () => {
  try {
    const newSkipCount = feedbackSkipCount + 1;
    
    if (isStorageInitialized && firestoreStorage.currentUser) {
      await firestoreStorage.updateUserData({
        'feedback.skipCount': newSkipCount,
        'feedback.lastSkippedAt': new Date().toISOString(),
        'feedback.hasShownOnce': true
      });
    }
    
    setFeedbackSkipCount(newSkipCount);
    setHasShownFeedbackOnce(true);
    setShowFeedbackPopup(false);
    
    // Show skip message
    if (newSkipCount === 1) {
      setSuccessMessage('We\'ll ask for your feedback after your next conversation.');
    } else if (newSkipCount >= 2) {
      setSuccessMessage('Your feedback helps us improve Preptune for everyone.');
    }
    setTimeout(() => setSuccessMessage(''), 3000);
    
    // Restore what was open before feedback
    restorePreviousModalState();
    
  } catch (error) {
    console.error('Failed to update feedback skip status:', error);
    setShowFeedbackPopup(false);
    restorePreviousModalState();
  }
};
const shouldShowFeedbackAfterCall = () => {
  return !feedbackCompleted;
};
// 🔥 NEW: Helper function to check if should show feedback (simplified)
// Show feedback after call ends with delay
const showFeedbackAfterCall = () => {
  setTimeout(() => {
    setShowFeedbackPopup(true);
  }, 500);
};

// 🔥 COMPLETELY REWRITTEN: Better initialization with proper state management
useEffect(() => {
  let mounted = true;
  
  const initializeApp = async () => {
    try {
      console.log('🚀 App initialization starting...');
      
      // Keep loading spinner visible during initialization
      setIsInitialLoading(true);
      
      // Set up auth listener
      const unsubscribeAuth = firestoreStorage.initializeAuthListener();
      
      const handleAuthStateChange = async (user) => {
        if (!mounted) return;
        
        try {
          if (!user) {
            console.log('❌ No authenticated user');
            if (mounted) {
              setUserFlow('error');
              setError('Please sign in to continue');
              setIsAppReady(true);
              setIsInitialLoading(false); // 🔥 Hide loading spinner
            }
            return;
          }

          console.log('👤 User authenticated:', user.email);
          
          // Wait for Firestore to be ready
          let attempts = 0;
          while (attempts < 10 && !firestoreStorage.isReady()) {
            console.log(`⏳ Waiting for Firestore... (${attempts + 1}/10)`);
            await new Promise(resolve => setTimeout(resolve, 150));
            attempts++;
          }

          if (!firestoreStorage.isReady()) {
            throw new Error('Firestore initialization timeout');
          }

          // Get user data
          const userData = await firestoreStorage.getUserData();
          setPersistentUserId(userData.preptuneUserId);
          
          // Determine user flow
          const hasVoicePreference = userData.settings?.preferredVoice;
          
          if (hasVoicePreference) {
            const voiceId = userData.settings.preferredVoice;
            const foundVoice = voicePreferenceService.getVoiceById(voiceId);
            
            if (foundVoice) {
              console.log('✅ Returning user with valid voice:', foundVoice.name);
              
              setCurrentVoice(foundVoice);
              setIsFirstTimeUser(false);
              setShowVoiceSelection(false);
              
              if (userData.settings?.guideCompleted) {
                setShowFirstTimeGuide(false);
                setHasCompletedGuide(true);
              } else {
                setShowFirstTimeGuide(true);
                setHasCompletedGuide(false);
              }
              
              setUserFlow('returning');
              voicePreferenceService.saveVoicePreference(voiceId);
              
            } else {
              console.log('⚠️ Voice preference invalid, treating as new user');
              await resetUserToNewFlow();
              setUserFlow('new');
              setIsFirstTimeUser(true);
              setShowVoiceSelection(true);
              setShowFirstTimeGuide(false);
              setHasCompletedGuide(false);
            }
          } else {
            console.log('🆕 New user - no voice preference found');
            setUserFlow('new');
            setIsFirstTimeUser(true);
            setShowVoiceSelection(true);
            setShowFirstTimeGuide(false);
            setHasCompletedGuide(false);
            setCurrentVoice(null);
          }

          // Load other preferences
          if (userData.settings?.soundEnabled !== undefined) {
            setSoundEnabled(userData.settings.soundEnabled);
          }

          // Resume data for completed users only
          if (userData.currentChatGroupId && userData.settings?.guideCompleted) {
            setCurrentChatGroupId(userData.currentChatGroupId);
            setCurrentChatId(userData.currentChatId);
          }

          // Mark as initialized
          setIsStorageInitialized(true);
          setIsAppReady(true);
          setIsInitialLoading(false); // 🔥 Hide loading spinner
          
          console.log('✅ App initialization complete');
          
        } catch (error) {
          console.error('❌ User initialization failed:', error);
          if (mounted) {
            setUserFlow('error');
            setError('Failed to load user data. Please refresh.');
            setIsAppReady(true);
            setIsInitialLoading(false); // 🔥 Hide loading spinner even on error
          }
        }
      };

      // Check current auth state immediately
      const currentUser = auth.currentUser;
      if (currentUser) {
        await handleAuthStateChange(currentUser);
      } else {
        // Wait for auth state change with timeout
        const authTimeout = setTimeout(() => {
          if (mounted) {
            console.log('⚠️ Auth timeout - treating as unauthenticated');
            setUserFlow('error');
            setError('Authentication required');
            setIsAppReady(true);
            setIsInitialLoading(false); // 🔥 Hide loading spinner
          }
        }, 5000);

        const unsubscribeTemp = auth.onAuthStateChanged(async (user) => {
          clearTimeout(authTimeout);
          unsubscribeTemp();
          await handleAuthStateChange(user);
        });
      }
      
      return () => {
        if (unsubscribeAuth) {
          unsubscribeAuth();
        }
      };
      
    } catch (error) {
      console.error('❌ App initialization error:', error);
      if (mounted) {
        setUserFlow('error');
        setError('App initialization failed. Please refresh.');
        setIsAppReady(true);
        setIsInitialLoading(false); // 🔥 Hide loading spinner
      }
    }
  };
  
  const cleanup = initializeApp();
  
  return () => {
    mounted = false;
    cleanup?.then?.(cleanupFn => cleanupFn?.());
  };
}, []); // Run once only


// Function to save current modal state
const saveCurrentModalState = () => {
  setModalStateBeforeFeedback({
    showSummary,
    showFirstTimeGuide,
    showVoiceSelection,
    showReminderSetModal,
    showReminderTriggeredModal,
    activeTab
  });
};


// State to track what was open before feedback popup
const [modalStateBeforeFeedback, setModalStateBeforeFeedback] = useState({
  showSummary: false,
  showFirstTimeGuide: false,
  showVoiceSelection: false,
  showReminderSetModal: false,
  showReminderTriggeredModal: false,
  activeTab: 'journal'
});

// Restore previous modal state after feedback is handled
const restorePreviousModalState = () => {
  const state = modalStateBeforeFeedback;
  
  setTimeout(() => {
    setShowSummary(state.showSummary);
    setShowFirstTimeGuide(state.showFirstTimeGuide);
    setShowVoiceSelection(state.showVoiceSelection);
    setShowReminderSetModal(state.showReminderSetModal);
    setShowReminderTriggeredModal(state.showReminderTriggeredModal);
    setActiveTab(state.activeTab);
  }, 150);
};

// Close all modals except feedback
const closeAllModalsExceptFeedback = () => {
  setShowSummary(false);
  setShowFirstTimeGuide(false);
  setShowVoiceSelection(false);
  setShowReminderSetModal(false);
  setShowReminderTriggeredModal(false);
};

// Automatically handle modal state when feedback popup appears
useEffect(() => {
  if (showFeedbackPopup) {
    saveCurrentModalState();
    closeAllModalsExceptFeedback();
  }
}, [showFeedbackPopup]);

const loadUserPreferencesWithoutFlash = async (userData) => {
  try {
    console.log('🔧 Loading user preferences without flashing...');
    
    // 🔥 CRITICAL: Determine states BEFORE setting them
    let voiceFound = false;
    let shouldShowVoiceSelection = false;
    let shouldShowGuide = false;
    let userIsFirstTime = true;
    let guideCompleted = false;
    let foundVoice = null;
    
    // Check voice preference
    if (userData.settings?.preferredVoice) {
      const voiceId = userData.settings.preferredVoice;
      foundVoice = voicePreferenceService.getVoiceById(voiceId);
      
      if (foundVoice) {
        console.log('✅ Voice found:', foundVoice.name);
        voiceFound = true;
        userIsFirstTime = false;
        shouldShowVoiceSelection = false;
        
        // Check guide status
        if (userData.settings?.guideCompleted) {
          console.log('✅ User has completed guide - ready to use app');
          guideCompleted = true;
          shouldShowGuide = false;
        } else {
          console.log('📖 Voice set but guide not completed');
          shouldShowGuide = true;
          guideCompleted = false;
        }
      } else {
        console.warn('⚠️ Saved voice no longer exists, resetting user');
        shouldShowVoiceSelection = true;
        userIsFirstTime = true;
        await resetUserToNewFlow();
      }
    } else {
      console.log('🆕 No voice preference - new user');
      shouldShowVoiceSelection = true;
      userIsFirstTime = true;
    }
    
    // 🔥 CRITICAL: Set ALL states at once in the correct order
    if (foundVoice) {
      setCurrentVoice(foundVoice);
      voicePreferenceService.saveVoicePreference(foundVoice.id);
    }
    
    setIsFirstTimeUser(userIsFirstTime);
    setShowVoiceSelection(shouldShowVoiceSelection);
    setShowFirstTimeGuide(shouldShowGuide);
    setHasCompletedGuide(guideCompleted);
    
    // Other preferences
    if (userData.settings?.soundEnabled !== undefined) {
      setSoundEnabled(userData.settings.soundEnabled);
    }
    
    // Resume data for completed users only
    if (userData.currentChatGroupId && 
        userData.settings?.firstTimeCompleted && 
        userData.settings?.guideCompleted) {
      setCurrentChatGroupId(userData.currentChatGroupId);
      setCurrentChatId(userData.currentChatId);
      console.log('🔄 Resume data loaded');
    }
    
    console.log('✅ Preferences loaded without flashing:', {
      voiceFound,
      shouldShowVoiceSelection,
      shouldShowGuide,
      userIsFirstTime
    });
    
  } catch (error) {
    console.error('❌ Failed to load preferences:', error);
    // On error, show voice selection for new users
    setIsFirstTimeUser(true);
    setShowVoiceSelection(true);
    setCurrentVoice(null);
    setShowFirstTimeGuide(false);
    setHasCompletedGuide(false);
  }
};
// 🔥 NEW: Immediate preference loading (no async delays)
const loadUserPreferencesImmediate = async (userData) => {
  try {
    console.log('🔧 Loading user preferences immediately...');
    
    // Voice preference handling
    if (userData.settings?.preferredVoice) {
      const voiceId = userData.settings.preferredVoice;
      const voicePreference = voicePreferenceService.getVoiceById(voiceId);
      
      if (voicePreference) {
        console.log('✅ Voice found:', voicePreference.name);
        
        // Set voice state immediately
        setCurrentVoice(voicePreference);
        setIsFirstTimeUser(false);
        setShowVoiceSelection(false);
        
        // Sync voicePreferenceService for UI consistency
        voicePreferenceService.saveVoicePreference(voiceId);
        
        // Check guide status
        if (userData.settings?.guideCompleted) {
          console.log('✅ User has completed guide - ready to use app');
          setHasCompletedGuide(true);
          setShowFirstTimeGuide(false);
        } else {
          console.log('📖 Voice set but guide not completed');
          setShowFirstTimeGuide(true);
          setHasCompletedGuide(false);
        }
        
      } else {
        console.warn('⚠️ Saved voice no longer exists, resetting user');
        await resetUserToNewFlow();
      }
    } else {
      console.log('🆕 No voice preference - new user');
      setNewUserFlow();
    }
    
    // Other preferences
    if (userData.settings?.soundEnabled !== undefined) {
      setSoundEnabled(userData.settings.soundEnabled);
    }
    
    // Resume data for completed users only
    if (userData.currentChatGroupId && 
        userData.settings?.firstTimeCompleted && 
        userData.settings?.guideCompleted) {
      setCurrentChatGroupId(userData.currentChatGroupId);
      setCurrentChatId(userData.currentChatId);
      console.log('🔄 Resume data loaded');
    }
    
    console.log('✅ Preferences loaded successfully');
    
  } catch (error) {
    console.error('❌ Failed to load preferences:', error);
    setNewUserFlow();
  }
};

// 🔥 NEW: Helper functions for cleaner state management
const setNewUserFlow = () => {
  setIsFirstTimeUser(true);
  setShowVoiceSelection(true);
  setCurrentVoice(null);
  setShowFirstTimeGuide(false);
  setHasCompletedGuide(false);
};

const resetUserToNewFlow = async () => {
  // Reset user in Firestore
  await firestoreStorage.updateUserData({
    'settings.preferredVoice': null,
    'settings.preferredVoiceName': null,
    'settings.preferredVoiceConfigId': null,
    'settings.firstTimeCompleted': false,
    'settings.guideCompleted': false
  });
  
  // Reset UI state
  setNewUserFlow();
};

// 🔥 NEW: Initialize Firestore storage and check authentication
useEffect(() => {
  const initializeFirestoreStorage = async () => {
    try {
      console.log('🔥 Initializing Firestore storage...');
      
      // Set up auth listener (don't wait for it)
      const unsubscribeAuth = firestoreStorage.initializeAuthListener();
      
      // Check current auth state
      const currentUser = auth.currentUser;
      if (currentUser) {
        console.log('✅ User already authenticated:', currentUser.email);
        
        // Wait for initialization to complete
        await firestoreStorage.initializeUserData();
        
        // Get user data and set states
        const userData = await firestoreStorage.getUserData();
        setPersistentUserId(userData.preptuneUserId);
        
        console.log('🎯 Preptune ID set:', userData.preptuneUserId);
        console.log('👤 User settings:', userData.settings);
        
        // 🔥 CRITICAL: Load user preferences and determine flow
        await loadUserPreferences(userData);
        
        setIsStorageInitialized(true);
        
      } else {
        console.log('⏳ Waiting for authentication...');
        
        // Wait for auth state to change
        const authPromise = new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error('Auth timeout')), 10000);
          
          const unsubscribe = auth.onAuthStateChanged(async (user) => {
            clearTimeout(timeout);
            unsubscribe();
            
            if (user) {
              console.log('✅ User authenticated:', user.email);
              resolve(user);
            } else {
              reject(new Error('User not authenticated'));
            }
          });
        });
        
        try {
          await authPromise;
          
          // Initialize after auth
          await firestoreStorage.initializeUserData();
          const userData = await firestoreStorage.getUserData();
          setPersistentUserId(userData.preptuneUserId);
          
          console.log('🎯 Preptune ID set:', userData.preptuneUserId);
          
          await loadUserPreferences(userData);
          setIsStorageInitialized(true);
          
        } catch (error) {
          console.error('❌ Authentication failed:', error);
          setError('Please sign in to continue');
          setIsStorageInitialized(true); // Still allow app to show error
        }
      }
      
    } catch (error) {
      console.error('❌ Failed to initialize Firestore storage:', error);
      setError('Failed to initialize. Please refresh and try again.');
      setIsStorageInitialized(true);
    }
  };

  initializeFirestoreStorage();
}, []); // Empty dependency array - only run once

// 🔥 NEW: Load user preferences from Firestore
const loadUserPreferences = async (userData) => {
  try {
    console.log('🔧 Loading user preferences for:', userData.email);
    console.log('📊 User data:', userData);
    
    // 🔥 VOICE PREFERENCE HANDLING - FIXED
    if (userData.settings?.preferredVoice) {
      const voiceId = userData.settings.preferredVoice;
      const voicePreference = voicePreferenceService.getVoiceById(voiceId);
      
      if (voicePreference) {
        console.log('✅ Voice loaded from Firestore:', voicePreference.name);
        setCurrentVoice(voicePreference);
        setIsFirstTimeUser(false);
        setShowVoiceSelection(false);
        
        // Keep voicePreferenceService for immediate UI consistency only
        voicePreferenceService.saveVoicePreference(voiceId);
        
        // 🔥 FIXED: Check guide status AFTER voice is set
        if (userData.settings?.guideCompleted) {
          console.log('✅ User has completed guide');
          setHasCompletedGuide(true);
          setShowFirstTimeGuide(false);
        } else {
          console.log('📖 Voice set but guide not completed - showing guide');
          setShowFirstTimeGuide(true);
          setHasCompletedGuide(false);
        }
        
      } else {
        console.warn('⚠️ Saved voice no longer exists:', voiceId);
        // Voice configuration no longer exists, reset to new user flow
        await firestoreStorage.updateUserData({
          'settings.preferredVoice': null,
          'settings.preferredVoiceName': null,
          'settings.preferredVoiceConfigId': null,
          'settings.firstTimeCompleted': false,
          'settings.guideCompleted': false
        });
        setIsFirstTimeUser(true);
        setShowVoiceSelection(true);
        setCurrentVoice(null);
        setShowFirstTimeGuide(false); // Guide comes after voice selection
      }
    } else {
      console.log('🆕 No voice preference - new user flow');
      setIsFirstTimeUser(true);
      setShowVoiceSelection(true);
      setCurrentVoice(null);
      setShowFirstTimeGuide(false); // Guide comes after voice selection
      setHasCompletedGuide(false);
    }
    
    // 🔥 OTHER PREFERENCES
    if (userData.settings?.soundEnabled !== undefined) {
      setSoundEnabled(userData.settings.soundEnabled);
    }
    
    // 🔥 RESUME DATA - Only for returning users with completed setup
    if (userData.currentChatGroupId && userData.settings?.firstTimeCompleted && userData.settings?.guideCompleted) {
      setCurrentChatGroupId(userData.currentChatGroupId);
      setCurrentChatId(userData.currentChatId);
      console.log('🔄 Resume data available for returning user');
    } else {
      console.log('🆕 No resume data - fresh start');
      setCurrentChatGroupId(null);
      setCurrentChatId(null);
    }
    
    console.log('✅ User preferences loaded successfully');
    
  } catch (error) {
    console.error('❌ Failed to load user preferences:', error);
    // On error, default to new user flow
    setIsFirstTimeUser(true);
    setShowVoiceSelection(true);
    setCurrentVoice(null);
    setShowFirstTimeGuide(false);
    setHasCompletedGuide(false);
  }
};

// 🔥 NEW: Load latest conversation from Firestore
const loadLatestConversation = async () => {
  try {
    const latestConversation = await firestoreStorage.getLatestConversation();
    if (latestConversation && latestConversation.messages && latestConversation.messages.length > 0) {
      setConversation(latestConversation.messages);
      setConversationSummary(latestConversation.summary || '');
      setSummaryHeader(latestConversation.summaryHeader || 'Today\'s Reflection');
      setEmotionalInsights(latestConversation.emotionalInsights || '');
      console.log('📂 Latest conversation loaded from Firestore:', latestConversation.messages.length, 'messages');
    }
  } catch (error) {
    console.error('❌ Failed to load latest conversation:', error);
  }
};
const isTimerExpired = () => {
  return timerInitialized && persistentTimeRemaining <= 0;
};

const showTrialExceededError = () => {
  setError('⏰ Trial time exceeded! Your 20-minute session has ended. Please refresh to start a new trial.'); // Changed from "5-minute" to "20-minute"
  setTimeout(() => setError(''), 5000);
};

// 🔥 NEW: Update session statistics from Firestore
const updateSessionStats = async () => {
  try {
    await firestoreStorage.updateUserStats();
    const userData = await firestoreStorage.getUserData();
    
    const stats = {
      totalSessions: userData.stats?.totalConversations || 0,
      totalMessages: userData.stats?.totalMessages || 0,
      averageSessionDuration: userData.stats?.averageSessionDuration || 0,
      accountCreated: userData.createdAt,
      lastActiveSession: userData.lastActiveAt,
      preptuneUserId: userData.preptuneUserId
    };
    
    setSessionStats(stats);
  } catch (error) {
    console.error('❌ Failed to update session stats:', error);
  }
};

// 🔥 NEW: Auto-save current conversation to Firestore
const autoSaveCurrentConversation = async () => {
  if (!persistentUserId || !currentChatGroupId || conversation.length === 0) return;
  
  try {
    const sessionData = {
      chatGroupId: currentChatGroupId,
      chatId: currentChatId,
      userId: persistentUserId,
      startTime: sessionStartTime?.toISOString() || new Date().toISOString(),
      messages: conversation,
      summary: conversationSummary,
      summaryHeader: summaryHeader,
      emotionalInsights: emotionalInsights,
      sessionType: 'auto-save',
      isComplete: false
    };

    const savedSession = await firestoreStorage.saveConversation(sessionData);
    if (savedSession && !currentSessionId) {
      setCurrentSessionId(savedSession.sessionId);
    }
    
    console.log('💾 Auto-saved session to Firestore (session data only, no journal)');
    
  } catch (error) {
    console.error('❌ Auto-save session failed:', error);
  }
};

// 🔥 NEW: Save complete conversation to Firestore
const saveCompleteConversation = async () => {
  if (!persistentUserId || conversation.length === 0) return;
  
  try {
    const sessionData = {
      chatGroupId: currentChatGroupId,
      chatId: currentChatId,
      userId: persistentUserId,
      startTime: sessionStartTime?.toISOString() || new Date().toISOString(),
      endTime: new Date().toISOString(),
      duration: sessionStartTime ? Date.now() - sessionStartTime.getTime() : 0,
      messages: conversation,
      summary: conversationSummary,
      summaryHeader: summaryHeader,
      emotionalInsights: emotionalInsights,
      sessionType: 'complete',
      isComplete: true
    };

    const savedSession = await firestoreStorage.saveConversation(sessionData);
    console.log('✅ Complete session saved to Firestore (session data only):', savedSession.sessionId);
    
    await firestoreStorage.updateUserData({
      currentChatGroupId: currentChatGroupId,
      currentChatId: currentChatId,
      lastActiveSession: new Date()
    });
    
    await updateSessionStats();
    
    // NO success message for session saves - user didn't request it
    return savedSession;
    
  } catch (error) {
    console.error('❌ Failed to save complete session:', error);
    // Don't show error to user for background session saves
  }
};

  // 🔥 UPDATED: Add message to conversation and save to Firestore
const addMessageToConversation = (message) => {
  setConversation(prev => {
    const updated = [...prev, message];
    
    // Only auto-save session data (not journal)
    if (currentChatGroupId && persistentUserId) {
      setTimeout(() => {
        autoSaveCurrentConversation();
      }, 100);
    }
    
    return updated;
  });
};

  // Updated saveJournalEntry function to use Firestore
const saveJournalEntry = async () => {
  const hasConversation = Array.isArray(conversation) && conversation.length > 0;
  const hasSummary = conversationSummary && conversationSummary.trim() !== '';
  const hasInsights = emotionalInsights && emotionalInsights.trim() !== '';
  
  if (!hasConversation && !hasSummary && !hasInsights) {
    setError('No content available to save. Start a conversation first.');
    setTimeout(() => setError(''), 3000);
    return;
  }
        
  setIsSaving(true);
  setError('');
        
  try {
    // Generate summary if missing but conversation exists
    let finalSummary = conversationSummary;
    let finalInsights = emotionalInsights;
    let finalHeader = summaryHeader || 'Today\'s Reflection';
    
    if (hasConversation && !hasSummary && azureOpenAIService.current) {
      console.log('📝 Generating summary for manual save...');
      try {
        const summaryResult = await azureOpenAIService.current.summarizeConversation(conversation);
        
        if (typeof summaryResult === 'object' && summaryResult.header && summaryResult.content) {
          finalHeader = summaryResult.header;
          finalSummary = summaryResult.content;
        } else if (typeof summaryResult === 'string') {
          finalSummary = summaryResult;
        }
        
        const hasEmotionalData = conversation.some(msg => msg.emotions && msg.emotions.length > 0);
        if (hasEmotionalData && !hasInsights) {
          try {
            finalInsights = await azureOpenAIService.current.generateEmotionalInsights(conversation);
          } catch (insightError) {
            console.warn('Could not generate insights:', insightError);
          }
        }
        
        setConversationSummary(finalSummary);
        setEmotionalInsights(finalInsights);
        setSummaryHeader(finalHeader);
        
      } catch (summaryError) {
        console.warn('Could not generate summary, using conversation as fallback:', summaryError);
        finalSummary = `Conversation from ${formatDate(new Date())} with ${conversation.length} messages`;
      }
    }
    
    const journalData = {
      header: finalHeader || 'Journal Entry',
      summary: finalSummary || `Conversation with ${conversation.length} messages`,
      insights: finalInsights || 'No emotional insights available',
      conversation: conversation || [],
      sessionStartTime: sessionStartTime?.toISOString() || new Date().toISOString(),
      userId: persistentUserId,
      messageCount: conversation?.length || 0,
      voiceName: currentVoice?.name || 'Unknown Voice',
      savedManually: true,
      hasGeneratedSummary: !!finalSummary,
      hasEmotionalInsights: !!finalInsights
    };
            
    console.log('💾 Manual journal save requested by user');
    
    let savedJournal;
    
    if (isStorageInitialized && firestoreStorage?.currentUser) {
      savedJournal = await firestoreStorage.saveJournalEntry(journalData);
      console.log('✅ Journal manually saved to Firestore:', savedJournal);
    } else {
      savedJournal = await journalStorageService.saveJournal(journalData);
      console.log('✅ Journal manually saved via JournalStorageService:', savedJournal);
    }
    
    setIsManuallySaved(true);
    
    const summaryLength = finalSummary ? finalSummary.length : 0;
    const hasInsightsText = finalInsights ? 'with insights' : 'without insights';
    
    setSuccessMessage(`✅ Journal saved successfully! (${summaryLength} characters ${hasInsightsText})`);
            
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
            
    return savedJournal;
          
  } catch (error) {
    console.error('❌ Manual journal save error:', error);
    
    let errorMessage = 'Failed to save journal: ';
    
    if (error.message.includes('not authenticated')) {
      errorMessage += 'Please sign in to save journals.';
    } else if (error.message.includes('network')) {
      errorMessage += 'Network error. Please check your connection.';
    } else if (error.message.includes('quota')) {
      errorMessage += 'Storage quota exceeded. Please free up space.';
    } else {
      errorMessage += error.message || 'Unknown error occurred.';
    }
    
    setError(errorMessage);
    setTimeout(() => setError(''), 5000);
    
  } finally {
    setIsSaving(false);
  }
};

// 🔥 HELPER: Format date for fallback summaries
const formatDate = (date) => {
  try {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric', 
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    return date.toString();
  }
};

  // Audio service instance
  const audioService = useRef(new AudioService());


  // 🔥 UPDATED: Voice selection handler to save to Firestore
const handleVoiceSelected = async (selectedVoice) => {
  if (!canOpenModal()) return;
  
  try {
    console.log('Voice selected:', selectedVoice.name);
    
    if (!selectedVoice || !selectedVoice.id || !selectedVoice.configId) {
      console.error('Invalid voice object:', selectedVoice);
      setError('Invalid voice selection. Please try again.');
      return;
    }
    
    setCurrentVoice(selectedVoice);
    setShowVoiceSelection(false);
    setIsFirstTimeUser(false);
    
    if (isStorageInitialized && firestoreStorage.currentUser) {
      await firestoreStorage.updateUserData({
        'settings.preferredVoice': selectedVoice.id,
        'settings.preferredVoiceName': selectedVoice.name,
        'settings.preferredVoiceConfigId': selectedVoice.configId,
        'settings.voiceSelectedAt': new Date().toISOString(),
        'settings.firstTimeCompleted': true
      });
      console.log('Voice preference saved to Firestore');
      voicePreferenceService.saveVoicePreference(selectedVoice.id);
    }
    
    const userData = await firestoreStorage.getUserData();
    const shouldShowGuide = !userData.settings?.guideCompleted;
    
    if (shouldShowGuide) {
      setShowFirstTimeGuide(true);
      setHasCompletedGuide(false);
    } else {
      setShowFirstTimeGuide(false);
      setHasCompletedGuide(true);
      setSuccessMessage(`${selectedVoice.name} selected! Ready to start your conversation.`);
      setTimeout(() => setSuccessMessage(''), 3000);
    }
    
  } catch (error) {
    console.error('Voice selection failed:', error);
    setError('Failed to select voice. Please try again.');
    setTimeout(() => setError(''), 3000);
  }
};




// 🔥 UPDATED: Handle guide completion to save to Firestore
const handleGuideComplete = async () => {
  if (!canOpenModal()) return;
  
  setShowFirstTimeGuide(false);
  setHasCompletedGuide(true);
  firstTimeService.markGuideCompleted();
  
  if (isStorageInitialized && firestoreStorage.currentUser) {
    try {
      await firestoreStorage.updateUserData({
        'settings.guideCompleted': true,
        'settings.firstTimeCompleted': true
      });
      console.log('Guide completion saved to Firestore');
    } catch (error) {
      console.error('Failed to save guide completion:', error);
    }
  }
  
  setSuccessMessage(`Welcome to Preptune! Ready to start your first conversation with ${currentVoice?.name}?`);
  setTimeout(() => setSuccessMessage(''), 4000);
};


// 🔥 UPDATED: Handle first call completion to save to Firestore
const handleStartFirstCall = async () => {
  if (!canOpenModal()) return;
  
  setShowFirstTimeGuide(false);
  setHasCompletedGuide(true);
  firstTimeService.markGuideCompleted();
  
  if (isStorageInitialized && firestoreStorage.currentUser) {
    try {
      await firestoreStorage.updateUserData({
        'settings.guideCompleted': true,
        'settings.firstTimeCompleted': true,
        'stats.firstCallCompleted': true
      });
      console.log('First call tracking saved to Firestore');
    } catch (error) {
      console.error('Failed to save first call tracking:', error);
    }
  }
  
  setTimeout(() => {
    startListening();
    firstTimeService.trackMilestone('first-call-started');
  }, 300);
};

  // NEW: Add this useEffect to check for voice preference on component mount
useEffect(() => {
  const initializeVoiceAndFirestore = async () => {
    if (!isStorageInitialized) return;
    
    console.log('🚀 Initializing voice and Firestore integration...');
    
    let voiceFound = false;
    
    try {
      // Step 1: ONLY try Firestore if user is authenticated
      if (firestoreStorage.currentUser && firestoreStorage.isInitialized) {
        console.log('👤 User authenticated, checking Firestore...');
        const userData = await firestoreStorage.getUserData();
        
        if (userData.settings?.preferredVoice) {
          const voiceId = userData.settings.preferredVoice;
          const voice = voicePreferenceService.getVoiceById(voiceId);
          
          if (voice) {
            console.log('☁️ Voice loaded from Firestore:', voice.name);
            setCurrentVoice(voice);
            setIsFirstTimeUser(false);
            setShowVoiceSelection(false);
            voiceFound = true;
            
            // Update localStorage cache
            voicePreferenceService.saveVoicePreference(voiceId);
            
            // Handle guide status
            if (userData.settings?.guideCompleted) {
              setHasCompletedGuide(true);
              setShowFirstTimeGuide(false);
            } else {
              setShowFirstTimeGuide(true);
              setHasCompletedGuide(false);
            }
          }
        }
      }
    } catch (error) {
      console.error('❌ Firestore voice load failed:', error);
    }
    
    // Step 2: New users start completely fresh (no localStorage fallback)
    // Firestore is the single source of truth
    
    // Step 3: New user - show voice selection
    if (!voiceFound) {
      console.log('🆕 New user or no saved voice - showing voice selection');
      setIsFirstTimeUser(true);
      setShowVoiceSelection(true);
      setShowFirstTimeGuide(false); // Guide comes after voice selection
      setCurrentVoice(null);
      setHasCompletedGuide(false);
    }
    
    console.log('✅ Voice initialization completed. Voice found:', voiceFound);
  };

  initializeVoiceAndFirestore();
}, [isStorageInitialized, firestoreStorage.isInitialized]);

// NEW: Function to change voice (for settings later)
const changeVoice = () => {
  setUserFlow('new');
  setShowVoiceSelection(true);
  setIsFirstTimeUser(true);
  setShowFirstTimeGuide(false);
};
// NEW: Get current voice theme colors for UI customization
const getCurrentThemeColors = () => {
  if (!currentVoice) return { primary: '#4F46E5', avatar: '🎯', theme: 'professional' };
  
  return {
    primary: currentVoice.color,
    avatar: currentVoice.avatar,
    theme: currentVoice.theme || 'professional'
  };
};
// Simple permission dialog component
const MicPermissionDialog = () => {
  if (!showMicPermissionDialog) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '400px',
        margin: '20px',
        textAlign: 'center'
      }}>
        
        <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>
          Allow Microphone Access?
        </h3>
        
        <p style={{ 
          color: '#666', 
          marginBottom: '25px', 
          fontSize: '13px',
          lineHeight: '1.4'
        }}>
          Allowing microphone access lets you have voice conversations with Preptune
        </p>
        
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button
            onClick={() => handleMicPermissionResponse(false)}
            style={{
              padding: '12px 24px',
              border: '2px solid #ddd',
              borderRadius: '8px',
              background: 'white',
              color: '#666',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            No Thanks
          </button>
          
          <button
            onClick={() => handleMicPermissionResponse(true)}
            style={{
              padding: '12px 24px',
              border: 'none',
              borderRadius: '8px',
              background: '#007bff',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Yes, Allow
          </button>
        </div>
      </div>
    </div>
  );
};

// 🔥 NEW: Add connection state reset function
const resetConnectionState = () => {
  setIsConnected(false);
  setConnectionStatus('disconnected');
  setIsRecording(false);
  setIsEviSpeaking(false);
  setIsPlaying(false);
  setCurrentChatGroupId(null);
  setCurrentChatId(null);
  setCurrentSessionId(null);
  
  if (wsRef.current) {
    wsRef.current = null;
  }
};




// UPDATED: Add voice info to the UI (add this to your render section)
const VoiceIndicator = () => {
  if (!currentVoice || showVoiceSelection) return null;
};

const handleEVIMessage = async (data) => {
  console.log('EVI Message:', data.type, data);
  
  switch (data.type) {
    case 'chat_metadata':
      if (data.chat_group_id || data.chat_id) {
        // Save to Firestore instead of localStorage
        if (isStorageInitialized && firestoreStorage.currentUser) {
          try {
            await firestoreStorage.updateUserData({
              currentChatGroupId: data.chat_group_id,
              currentChatId: data.chat_id,
              lastActiveAt: new Date()
            });
            console.log('Session IDs saved to Firestore');
          } catch (error) {
            console.error('Failed to save session IDs to Firestore:', error);
          }
        }
        
        setCurrentChatGroupId(data.chat_group_id);
        setCurrentChatId(data.chat_id);
      }
      break;

    case 'user_message':
      console.log('User message received:', data.message?.content);
      
      // Stop EVI audio when user speaks
      if (playerRef.current) {
        playerRef.current.stop();
      }
      // Reset any custom audio states
      audioService.current.resetForNewUserTurn();
      
      const userContent = data.message?.content || '';
      
      const userMessage = {
        type: 'user',
        content: userContent,
        timestamp: new Date(),
        messageId: data.message?.id || Date.now(),
        emotions: data.models?.prosody?.scores || []
      };
      
      addMessageToConversation(userMessage);
      setLastActivity(new Date());
      
      // Check for reminder requests
      checkForReminderRequest(userContent);
      
      if (!sessionActive) {
        setSessionActive(true);
        setSessionStartTime(new Date());
      }
      
      if (data.models?.prosody?.scores && Array.isArray(data.models.prosody.scores) && data.models.prosody.scores.length > 0) {
        const topEmotion = data.models.prosody.scores.reduce((max, emotion) => 
          emotion.score > max.score ? emotion : max
        );
        setCurrentEmotion(topEmotion.name);
      }
      break;
      
    case 'assistant_message':
      console.log('Assistant message received:', data.message?.content);
      
      const assistantContent = data.message?.content || '';
      
      // Filter repetitive welcome messages
      const isWelcomeBackMessage = 
        assistantContent.toLowerCase().includes('welcome back') ||
        assistantContent.toLowerCase().includes('good to have you back') ||
        assistantContent.toLowerCase().includes('nice to see you again') ||
        assistantContent.toLowerCase().includes('continuing our conversation') ||
        assistantContent.toLowerCase().includes('where we left off') ||
        assistantContent.toLowerCase().includes('glad you\'re back') ||
        assistantContent.toLowerCase().includes('great to see you') ||
        assistantContent.toLowerCase().includes('picking up where') ||
        assistantContent.toLowerCase().includes('resuming our');
      
      // Skip welcome messages if resuming or have conversation
      const shouldSkipMessage = isWelcomeBackMessage && (
        isResuming || 
        conversation.length > 0 ||
        currentChatGroupId ||
        contextInjected
      );
      
      if (shouldSkipMessage) {
        console.log('Skipping repetitive welcome/resume message:', assistantContent.substring(0, 50) + '...');
        return;
      }
      
      setResponse(assistantContent);
      setShowResponse(true);
      setIsEviSpeaking(true);
      
      const assistantMessage = {
        type: 'assistant',
        content: assistantContent,
        timestamp: new Date(),
        messageId: data.message?.id || Date.now(),
        emotions: data.models?.prosody?.scores || []
      };
      
      addMessageToConversation(assistantMessage);
      setLastActivity(new Date());
      
      break;
      
    case 'audio_output':
      try {
        if (soundEnabled && playerRef.current) {
          // Use Hume's EVIWebAudioPlayer to handle EVI audio
          await playerRef.current.enqueue(data);
          setIsPlaying(true);
        }
      } catch (err) {
        console.error('Audio playback error:', err);
        setIsPlaying(false);
      }
      break;
      
    case 'assistant_prosody':
      // Handle prosody data from assistant (emotional analysis)
      console.log('Assistant prosody received');
      if (data.models?.prosody?.scores && Array.isArray(data.models.prosody.scores) && data.models.prosody.scores.length > 0) {
        const topEmotion = data.models.prosody.scores.reduce((max, emotion) => 
          emotion.score > max.score ? emotion : max
        );
        setCurrentEmotion(`Assistant: ${topEmotion.name}`);
      }
      break;
      
    case 'assistant_end':
      console.log('Assistant finished speaking');
      
      setIsEviSpeaking(false);
      setIsPlaying(false);
      
      // MESSAGE STAYS VISIBLE - removed auto-hide timeout
      // Messages will only be cleared when call ends or user starts over
      
      // Resume recording after assistant finishes
      setTimeout(() => {
        if (isConnected && !isRecording && !callEnded && !isEviSpeaking) {
          console.log('Resuming recording after assistant end');
          startRecording();
        }
      }, 500);
      break;
      
    case 'user_interruption':
      console.log('User interrupted assistant');
      
      // Stop EVI audio immediately
      if (playerRef.current) {
        playerRef.current.stop();
      }
      
      setIsEviSpeaking(false);
      setIsPlaying(false);
      
      // Clear message on interruption (optional - remove these lines if you want to keep message visible)
      setShowResponse(false);
      setResponse('');
      
      // Quick resume of recording after interruption
      setTimeout(() => {
        if (isConnected && !isRecording && !callEnded) {
          console.log('Ensuring recording continues after interruption');
          startRecording();
        }
      }, 200);
      break;
      
    case 'connection_end':
    case 'call_end':
      console.log('Connection/call ended');
      
      setIsConnected(false);
      setConnectionStatus('disconnected');
      setIsEviSpeaking(false);
      setIsPlaying(false);
      
      // Clear messages when call actually ends
      setShowResponse(false);
      setResponse('');
      
      if (isRecording) {
        console.log('Stopping recording due to connection end');
        stopRecording();
      }
      
      // Stop all audio
      if (playerRef.current) {
        playerRef.current.stop();
      }
      audioService.current.stopAllAudio();
      
      addMessageToConversation({
        type: 'system',
        content: 'Connection ended',
        timestamp: new Date()
      });
      
      // Save complete session - NO JOURNAL AUTO-SAVE
      setTimeout(async () => {
        await saveCompleteConversation(); // This only saves session data, not journal
        
        // Handle journal request notifications but DON'T auto-generate
        if (journalRequested && conversation.length > 2) {
          setShowViewJournalButton(true);
          setTakingNoteMessage(false);
          setJournalButtonClicked(false);
          setSuccessMessage('Call ended. Click "Generate Journal" to create your reflection.');
          setTimeout(() => setSuccessMessage(''), 4000);
        }
        
        setJournalRequested(false);
        // REMOVED: await saveConversationToDataStore(); - No auto journal saves!
      }, 500);
      break;
      
    case 'error':
      console.error('EVI Error received:', data.message || data.error);
      setError(`EVI Error: ${data.message || data.error || 'Unknown error'}`);
      
      if (data.code === 'rate_limit_exceeded') {
        setError('Rate limit exceeded. Please wait before trying again.');
      } else if (data.code === 'authentication_failed') {
        setError('Authentication failed. Please check your API key.');
        setConnectionStatus('error');
      }
      break;
      
    default:
      console.log('Unknown EVI message type:', data.type, data);
  }
  
  // REMOVED: All saveConversationToDataStore calls
  // Only update last activity for session tracking
  setLastActivity(new Date());
};
// 4. UPDATE getBuddyClasses to remove pre-response references:
const getBuddyClasses = () => {
  let classes = 'buddy-circle';
  if (isConnected) classes += ' connected';
  if (isRecording) classes += ' listening';
  if (isEviSpeaking) classes += ' speaking';
  if (autoSummaryPending) classes += ' processing';
  if (isInitializing) classes += ' initializing';
  if (startupSoundPlaying) classes += ' startup-sound';
  // 🔥 REMOVED: pre-response sound class
  
  // Add voice theme class
  if (currentVoice) {
    classes += ` voice-${currentVoice.id}`;
  }
  
  return classes;
};

const connectToEVI = async (resumeChatGroupId = null, skipCallingBehavior = false) => {
  try {
    // CRITICAL: Timer expiration check at start of connection
    if (isTimerExpired()) {
      showTrialExceededError();
      setCallEnded(true);
      return;
    }
    
    console.log('🔗 connectToEVI called with timer remaining:', persistentTimeRemaining);
    
    // Existing connection check
    if (wsRef.current && (wsRef.current.readyState === WebSocket.CONNECTING || wsRef.current.readyState === WebSocket.OPEN)) {
      console.log('⚠️ WebSocket already connecting/connected, aborting new connection');
      return;
    }
    
    // Voice validation
    if (!currentVoice || !currentVoice.configId) {
      console.error('❌ No voice selected or missing configId:', currentVoice);
      setError('Please select a voice companion first');
      setShowVoiceSelection(true);
      return;
    }
    
    const voiceConfigId = currentVoice.configId;
    if (!voiceConfigId || voiceConfigId.includes('your-') || voiceConfigId.includes('-config-id-here')) {
      setError(`Invalid configuration for ${currentVoice.name}. Please contact support.`);
      console.error('❌ Invalid CONFIG_ID for voice:', currentVoice.name, voiceConfigId);
      return;
    }

    // CRITICAL: Final timer check before proceeding
    if (persistentTimeRemaining <= 0) {
      showTrialExceededError();
      setCallEnded(true);
      return;
    }

    setConnectionStatus('connecting');
    setIsInitializing(true);
    setError('');
    setContextInjected(false);

    if (!HUME_API_KEY || HUME_API_KEY === 'hj') {
      throw new Error('Please set your Hume API key in the environment variables');
    }

    console.log(`🎯 Connecting with ${currentVoice.name}, time remaining: ${persistentTimeRemaining}s`);

    // 🔥 IMPROVED: Better resume logic to prevent repetitive messages
    if (resumeChatGroupId) {
      setIsResuming(true);
      console.log('🔄 Loading conversation for resume...');
      
      const latestConversation = await firestoreStorage.getLatestConversation();
      if (latestConversation && latestConversation.messages) {
        // Filter out system messages and old welcome messages
        const userMessages = latestConversation.messages.filter(msg => 
          msg.type !== 'system' && 
          !(msg.type === 'assistant' && (
            msg.content.toLowerCase().includes('welcome back') ||
            msg.content.toLowerCase().includes('good to have you back') ||
            msg.content.toLowerCase().includes('resuming our')
          ))
        );
        
        setConversation(userMessages);
        setContextInjected(true); // Mark that we've already loaded context
        console.log('📂 Loaded conversation from Firestore for UI display:', userMessages.length, 'messages');
      }
    } else {
      setConversation([]);
      setIsResuming(false);
      setContextInjected(false);
    }

    // Build WebSocket URL
    let wsUrl = `${EVI_WS_URL}?apiKey=${HUME_API_KEY}&config_id=${voiceConfigId}`;
    
    if (persistentUserId) {
      wsUrl += `&user_id=${persistentUserId}`;
    }
    
    if (resumeChatGroupId) {
      wsUrl += `&resumed_chat_group_id=${resumeChatGroupId}`;
      console.log('🔄 Native EVI resume for session:', resumeChatGroupId);
    }

    console.log('🌐 WebSocket connecting...');
    
    // Ensure old WebSocket is properly closed before creating new one
    if (wsRef.current) {
      wsRef.current.close();
      wsRef.current = null;
    }
    
    wsRef.current = new WebSocket(wsUrl);

    wsRef.current.onopen = async () => {
      // CRITICAL: Final timer check after connection established
      if (isTimerExpired()) {
        console.log('⏰ Timer expired during connection, closing immediately');
        wsRef.current.close();
        showTrialExceededError();
        setCallEnded(true);
        return;
      }

      setIsConnected(true);
      setConnectionStatus('connected');
      console.log(`🟢 Connected to Hume EVI with ${currentVoice.name}`);

      // 🔥 IMPROVED: Only add connection message if not resuming or conversation is empty
      if (!resumeChatGroupId || conversation.length === 0) {
        if (resumeChatGroupId) {
          addMessageToConversation({
            type: 'system',
            content: `Resumed session with ${currentVoice.name} 🔄`,
            timestamp: new Date()
          });
        } else {
          addMessageToConversation({
            type: 'system',
            content: `Connected with ${currentVoice.name} 🎙️`,
            timestamp: new Date()
          });
        }
      }

      // Audio initialization
      try {
        if (playerRef.current) {
          await playerRef.current.init();
        }
        
        audioService.current.setStateChangeCallback((audioStates) => {
          setStartupSoundPlaying(audioStates.startupSoundPlaying);
          setIsInitializing(audioStates.isInitializing);
        });
        
        const audioPromise = audioService.current.initializeAllAudio();
        const timerPromise = resumeTimerIfNeeded();
        
        await Promise.all([audioPromise, timerPromise]);
        
        // Skip startup sound if we're resuming and already have conversation
        if (!skipCallingBehavior && !(resumeChatGroupId && conversation.length > 0)) {
          await audioService.current.playStartupSound(800);
        }
        
      } catch (error) {
        console.error('Audio initialization failed:', error);
      } finally {
        setIsInitializing(false);
        
        setTimeout(async () => {
          if (wsRef.current?.readyState === WebSocket.OPEN && !isTimerExpired()) {
            await startRecording();
          }
        }, 400);
      }

      setIsResuming(false);
      
      if (!sessionActive) {
        setSessionActive(true);
        setSessionStartTime(new Date());
      }
    };

    // Keep existing message handlers
    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      handleEVIMessage(data);
    };

    wsRef.current.onclose = (event) => {
      console.log('WebSocket closed with code:', event.code, 'reason:', event.reason);
      setIsConnected(false);
      setConnectionStatus('disconnected');
      setIsRecording(false);
      setContextInjected(false);
      setIsEviSpeaking(false);
      setIsPlaying(false);
      setIsResuming(false);
      
      audioService.current.stopAllAudio();
    };

    wsRef.current.onerror = (error) => {
      console.error('WebSocket error:', error);
      setError(`Connection failed with ${currentVoice.name}. Check your API key and config ID (${voiceConfigId})`);
      setConnectionStatus('error');
      setIsInitializing(false);
      setIsResuming(false);
    };

  } catch (err) {
    console.error('❌ connectToEVI error:', err);
    setError('Failed to connect: ' + err.message);
    setConnectionStatus('error');
    setIsInitializing(false);
    setIsResuming(false);
  }
};

const startRecording = async () => {
  if (isRecording) {
    console.log('⚠️ Already recording, skipping...');
    return;
  }
  
  try {
    console.log('🎤 Starting recording...');
    
    // iOS-optimized media stream configuration
    const audioConstraints = {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      sampleRate: 44100,
      channelCount: 1
    };
    
    // Add iOS-specific constraints for Chrome on iOS
    if (/CriOS/i.test(navigator.userAgent)) {
      Object.assign(audioConstraints, {
        googEchoCancellation: true,
        googAutoGainControl: true,
        googNoiseSuppression: true,
        googHighpassFilter: true
      });
    }
    
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: audioConstraints
    });
    
    console.log('✅ Recording stream obtained');
    console.log('📊 Stream info:', {
      active: stream.active,
      audioTracks: stream.getAudioTracks().length,
      settings: stream.getAudioTracks()[0]?.getSettings?.()
    });
    
    streamRef.current = stream;
    
    // Determine best MIME type for device
    let mimeType;
    if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
      mimeType = 'audio/webm;codecs=opus';
    } else if (MediaRecorder.isTypeSupported('audio/mp4;codecs=mp4a.40.2')) {
      mimeType = 'audio/mp4;codecs=mp4a.40.2';
    } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
      mimeType = 'audio/mp4';
    } else if (MediaRecorder.isTypeSupported('audio/webm')) {
      mimeType = 'audio/webm';
    } else {
      mimeType = ''; // Let browser choose
    }
    
    console.log('🎵 Using MIME type:', mimeType || 'browser default');
    
    const mediaRecorderOptions = {
      audioBitsPerSecond: 128000
    };
    
    if (mimeType) {
      mediaRecorderOptions.mimeType = mimeType;
    }
    
    const mediaRecorder = new MediaRecorder(stream, mediaRecorderOptions);
    mediaRecorderRef.current = mediaRecorder;
    
    // Handle audio data
    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        console.log('📦 Audio data available:', event.data.size, 'bytes');
        
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
          try {
            wsRef.current.send(event.data);
            console.log('📤 Audio data sent to EVI');
          } catch (error) {
            console.error('❌ Failed to send audio data:', error);
          }
        } else {
          console.warn('⚠️ WebSocket not ready, dropping audio data');
        }
      }
    };
    
    mediaRecorder.onstart = () => {
      console.log('✅ MediaRecorder started');
      setIsRecording(true);
    };
    
    mediaRecorder.onstop = () => {
      console.log('🛑 MediaRecorder stopped');
      setIsRecording(false);
    };
    
    mediaRecorder.onerror = (event) => {
      console.error('❌ MediaRecorder error:', event.error);
      setError(`Recording error: ${event.error?.message || 'Unknown error'}. Please try again.`);
      stopRecording();
    };
    
    // iOS needs smaller time slices for better performance
    const timeSlice = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 100 : 250;
    console.log('⏱️ Using time slice:', timeSlice, 'ms');
    
    mediaRecorder.start(timeSlice);
    console.log('🎙️ Recording started successfully');
    
  } catch (error) {
    console.error('❌ Failed to start recording:', error);
    
    let errorMessage = 'Failed to start recording. ';
    
    switch (error.name) {
      case 'NotAllowedError':
        errorMessage += 'Microphone access denied. Please refresh and allow access.';
        break;
      case 'NotFoundError':
        errorMessage += 'No microphone detected on this device.';
        break;
      case 'NotSupportedError':
        errorMessage += 'Recording not supported in this browser.';
        break;
      case 'NotReadableError':
        errorMessage += 'Microphone is being used by another application.';
        break;
      default:
        errorMessage += error.message || 'Unknown error occurred.';
    }
    
    setError(errorMessage);
    setIsRecording(false);
    
    // Clean up on error
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  }
};




// 🔥 UPDATED: toggleSound to use AudioService and save to Firestore
// Update your toggleSound function
const toggleSound = async () => {
  const newSoundState = !soundEnabled;
  setSoundEnabled(newSoundState);
  
  if (!newSoundState) {
    // Stop all audio when turning sound off
    if (playerRef.current) {
      playerRef.current.stop();
      setIsPlaying(false);
    }
    audioService.current.stopAllAudio();
  }
  
  // Update AudioService state
  audioService.current.toggleSound();
  
  // Save to Firestore
  if (isStorageInitialized && firestoreStorage.currentUser) {
    try {
      await firestoreStorage.updateUserData({
        'settings.soundEnabled': newSoundState
      });
      console.log('✅ Sound preference saved to Firestore:', newSoundState);
    } catch (error) {
      console.error('Failed to save sound preference:', error);
    }
  }
};

// 🔥 UPDATED: Initialize AudioService properly in useEffect
// Update your useEffect initialization
useEffect(() => {
  if (!isStorageInitialized) return;
 
  // Initialize services
  if (AZURE_OPENAI_ENDPOINT && AZURE_OPENAI_API_KEY) {
    azureOpenAIService.current = new AzureOpenAIService(
      AZURE_OPENAI_ENDPOINT,
      AZURE_OPENAI_API_KEY,
      AZURE_OPENAI_DEPLOYMENT
    );
  }
 
  // Initialize Hume's EVIWebAudioPlayer for EVI audio
  playerRef.current = new EVIWebAudioPlayer();
 
  // Initialize your custom AudioService for startup sounds only
  audioService.current.setStateChangeCallback((audioStates) => {
    setStartupSoundPlaying(audioStates.startupSoundPlaying);
    setSoundEnabled(audioStates.soundEnabled);
    setIsInitializing(audioStates.isInitializing);
  });
 
  // Initialize startup audio
  audioService.current.initializeAllAudio();
     
  return () => {
    // Cleanup
    if (sessionTimeoutRef.current) {
      clearTimeout(sessionTimeoutRef.current);
    }
    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }
    if (wsRef.current) {
      wsRef.current.close();
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
    }
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
         
    // Cleanup Hume player
    if (playerRef.current) {
      playerRef.current.stop();
    }
         
    // Cleanup AudioService
    audioService.current.cleanup();
         
    // Cleanup Firestore service
    if (firestoreStorage) {
      firestoreStorage.cleanup();
    }
  };
}, [isStorageInitialized]);

// Save conversation to data store (legacy)
const saveConversationToDataStore = async (conversationData) => {
  // This function should ONLY be called from manual save operations
  if (!firestoreStorage || !conversationData || !conversationData.length) {
    console.warn('Cannot save journal: missing storage service or conversation data');
    return;
  }

  // Only proceed if this is a manual save operation
  if (!isManuallySaved && !journalRequested) {
    console.log('📝 Skipping journal save - not manually requested by user');
    return;
  }

  try {
    console.log('📝 Saving journal (user requested)...');
    
    const journalData = {
      title: summaryHeader || 'Today\'s Reflection',
      header: summaryHeader || 'Today\'s Reflection', 
      summary: conversationSummary || 'No summary generated',
      insights: emotionalInsights || 'No insights generated',
      conversation: [...conversationData],
      sessionStartTime: sessionStartTime || new Date().toISOString(),
      sessionEndTime: new Date().toISOString(),
      question: '',
      userId: firestoreStorage?.getPreptuneUserId() || 'anonymous',
      wasManuallyRequested: true // Mark as user-requested
    };

    const savedJournal = await firestoreStorage.saveJournalEntry(journalData);
    console.log('✅ Journal saved successfully (user requested):', savedJournal.id);
    
    return savedJournal;
  } catch (error) {
    console.error('❌ Failed to save journal:', error);
    throw error;
  }
};

// Updated generateConversationSummary function
const generateConversationSummary = async (conversationData, showDropdown = true) => {
  if (!azureOpenAIService.current || conversationData.length === 0) {
    setError('No conversation to summarize or Azure OpenAI not configured');
    return;
  }
     
  if (showDropdown) {
    setShowSummary(true);
  }
     
  setIsGeneratingSummary(true);
  setError('');
  setDisplayedHeader('');
  setDisplayedSummary('');
  setDisplayedInsights('');
     
  try {
    await new Promise(resolve => setTimeout(resolve, 1000));
         
    const summaryResult = await azureOpenAIService.current.summarizeConversation(conversationData);
         
    if (typeof summaryResult === 'object' && summaryResult.header && summaryResult.content) {
      setSummaryHeader(summaryResult.header);
      setConversationSummary(summaryResult.content);
    } else {
      setSummaryHeader('Today\'s Reflection');
      setConversationSummary(summaryResult);
    }
         
    const hasEmotionalData = conversationData.some(msg => msg.emotions && msg.emotions.length > 0);
         
    if (hasEmotionalData) {
      const insights = await azureOpenAIService.current.generateEmotionalInsights(conversationData);
      setEmotionalInsights(insights);
    }
    
    // NO AUTO-SAVE HERE - user must manually save journal
    console.log('📝 Summary generated - user must manually save journal');
         
    if (showDropdown) {
      setSuccessMessage('Journal generated! Use "Save Journal" to save it.');
      setTimeout(() => setSuccessMessage(''), 3000);
    }
       
  } catch (error) {
    setError('Failed to generate summary: ' + error.message);
    console.error('Summary generation error:', error);
  } finally {
    setIsGeneratingSummary(false);
  }
};

// 🔥 UPDATED: handleStartOver with Firestore cleanup
// Update your handleStartOver function
const handleStartOver = async () => {
    console.log('Starting over - clearing all conversation memory...');
         
    if (sessionActive) {
      await endSession(false);
    }
         
    if (playerRef.current) {
      playerRef.current.stop();
    }
    audioService.current.stopAllAudio();
         
    if (wsRef.current) {
      if (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING) {
        wsRef.current.close(1000, 'Starting over');
      }
      wsRef.current = null;
    }
         
    stopRecording();
         
    if (isStorageInitialized && firestoreStorage.currentUser) {
      try {
        await firestoreStorage.updateUserData({
          currentChatGroupId: null,
          currentChatId: null,
          lastActiveSession: new Date()
        });
        console.log('Firestore session data cleared for fresh start');
      } catch (error) {
        console.error('Failed to clear Firestore session data:', error);
      }
    }
         
    // Reset all states
    setIsConnected(false);
    setConnectionStatus('disconnected');
    setIsRecording(false);
    setIsEviSpeaking(false);
    setIsPlaying(false);
    setIsInitializing(false);
    setConversation([]);
    setConversationSummary('');
    setEmotionalInsights('');
    setSummaryHeader('');
    setCurrentEmotion('');
    setMessage('');
    setResponse('');
    setShowResponse(false);
    setSessionActive(false);
    setSessionStartTime(null);
    setLastActivity(null);
    setAutoSummaryPending(false);
    setCurrentChatGroupId(null);
    setCurrentChatId(null);
    setCurrentSessionId(null);
    setContextInjected(false);
    setIsResuming(false);
    setJournalRequested(false);
    setJournalButtonClicked(false);
    setTakingNoteMessage(false);
    setShowViewJournalButton(false);
    setIsManuallySaved(false);
    setShowSummary(false);
    setActiveTab('Listen');
    setDisplayedSummary('');
    setDisplayedInsights('');
    setDisplayedHeader('');
    setIsGeneratingSummary(false);
    
    // REMOVE THESE TIMER-RELATED LINES:
    // setTimeRemaining(1200);
    // setCallEnded(false);
    // setTimerStarted(false);
    // if (timerRef.current) {
    //   clearInterval(timerRef.current);
    //   timerRef.current = null;
    // }
    
    setReminderRequested(false);
    setCurrentReminder(null);
    setShowReminderSetModal(false);
    setShowReminderTriggeredModal(false);
         
    typingTimeouts.forEach(timeout => clearTimeout(timeout));
    setTypingTimeouts([]);
         
    setError('');
    setSuccessMessage('');
         
    const audioStates = audioService.current.getAudioStates();
    setStartupSoundPlaying(audioStates.startupSoundPlaying);
         
    console.log('All conversation memory and connections cleared. Ready for fresh start.');
         
    setSuccessMessage('Cleared! Ready for a fresh conversation.');
    setTimeout(() => setSuccessMessage(''), 2000);
};



// 🔥 UPDATED: stopRecording to pause persistent timer

// 🔥 OPTIMIZED: Faster stopRecording
const stopRecording = () => {
  console.log('🛑 Stopping recording...');
  
  let recordingStopped = false;
  let streamStopped = false;
  
  // Stop MediaRecorder
  if (mediaRecorderRef.current) {
    try {
      if (mediaRecorderRef.current.state !== 'inactive') {
        mediaRecorderRef.current.stop();
        recordingStopped = true;
      }
    } catch (error) {
      console.log('MediaRecorder already stopped:', error);
    }
    mediaRecorderRef.current = null;
  }
  
  // Stop media stream
  if (streamRef.current) {
    try {
      streamRef.current.getTracks().forEach(track => {
        console.log('🛑 Stopping track:', track.kind, track.readyState);
        track.stop();
      });
      streamStopped = true;
    } catch (error) {
      console.log('Stream tracks already stopped:', error);
    }
    streamRef.current = null;
  }
  
  setIsRecording(false);
  
  console.log('✅ Recording cleanup completed:', {
    recordingStopped,
    streamStopped
  });
};


// 🔥 NEW: Quick timer resume function for faster subsequent calls
const resumeTimerIfNeeded = async () => {
  if (!timerInitialized || timerStarted || persistentTimeRemaining <= 0) {
    return false;
  }
  
  try {
    const started = await callTimerService.startTimer();
    if (started) {
      setTimerStarted(true);
      console.log('⚡ Quick timer resume:', persistentTimeRemaining, 'seconds');
      return true;
    }
  } catch (error) {
    console.error('Quick timer resume failed:', error);
  }
  
  return false;
};


// 🔥 NEW: Reset timer function
const resetTimer = async () => {
  try {
    await callTimerService.resetTimer();
    setCallEnded(false);
    setTimerStarted(false);
    setSuccessMessage('⏰ Timer reset to 20 minutes!'); // Changed message from "5 minutes" to "20 minutes"
    setTimeout(() => setSuccessMessage(''), 3000);
  } catch (error) {
    console.error('Failed to reset timer:', error);
    setError('Failed to reset timer');
    setTimeout(() => setError(''), 3000);
  }
};

// 🔥 NEW: Admin timer reset function
const adminResetTimer = async (targetUserId = null) => {
  try {
    const currentUser = firestoreStorage.getCurrentUserInfo();
    if (!currentUser) {
      setError('Must be authenticated');
      return;
    }
    
    if (targetUserId) {
      // Reset another user's timer
      await callTimerService.adminResetUserTimer(targetUserId, currentUser.preptuneUserId);
      setSuccessMessage(`⏰ Admin: Reset timer for user ${targetUserId.slice(-8)}`);
    } else {
  // Reset own timer
  await callTimerService.resetTimer(currentUser.preptuneUserId);
  setCallEnded(false);
  setTimerStarted(false);
  setSuccessMessage('⏰ Admin: Timer reset to 20 minutes!'); // Changed message from "5 minutes" to "20 minutes"
}
    setTimeout(() => setSuccessMessage(''), 3000);
  } catch (error) {
    console.error('Admin timer reset failed:', error);
    setError('Admin timer reset failed: ' + error.message);
    setTimeout(() => setError(''), 3000);
  }
};

const TimerDisplay = () => {
  // Only show the component when trial has expired
  if (!timerInitialized || persistentTimeRemaining > 0) return null;
     
  return (
    <div 
      className="timer-display expired"
      style={{
        color: '#ffffffff', // Red for expired
        fontWeight: '400',
        fontSize: '13px'
      }}
    >
      ⏰ TRIAL ENDED
    </div>
  );
};
// Admin Timer Controls Component
const AdminTimerControls = () => {
  const [targetUserId, setTargetUserId] = useState('');
  
  // Check if current user is admin
  const currentUser = firestoreStorage.getCurrentUserInfo();
  const adminEmails = ['admin@yourcompany.com']; // Configure your admin emails
  const isAdmin = currentUser && adminEmails.includes(currentUser.email);
  
  if (!isAdmin) return null;
  
  return (
    <div className="admin-timer-controls" style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(255,0,0,0.1)',
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid red',
      fontSize: '12px'
    }}>
      <h4 style={{ color: 'red', margin: '0 0 10px 0' }}>🔧 Admin Controls</h4>
      
      <button 
        onClick={() => adminResetTimer()}
        style={{ marginRight: '5px', fontSize: '11px' }}
      >
        Reset My Timer
      </button>
      
      <div style={{ marginTop: '10px' }}>
        <input
          type="text"
          placeholder="User ID to reset"
          value={targetUserId}
          onChange={(e) => setTargetUserId(e.target.value)}
          style={{ fontSize: '11px', width: '120px' }}
        />
        <button 
          onClick={() => adminResetTimer(targetUserId)}
          disabled={!targetUserId.trim()}
          style={{ marginLeft: '5px', fontSize: '11px' }}
        >
          Reset User Timer
        </button>
      </div>
    </div>
  );
};

// 5. Add cleanup in your cleanup useEffect:
useEffect(() => {
  return () => {
    // Existing cleanup code...
    
    // 🔥 NEW: Cleanup persistent timer
    if (callTimerService) {
      callTimerService.cleanup();
    }
  };
}, []);


// 🔥 UPDATED: endSession to work with AudioService
const endSession = async (autoEnd = false) => {
  if (!sessionActive) return;

  console.log('Session ending...', autoEnd ? '(auto-end)' : '(manual)', 'Recording:', isRecording);
  setSessionActive(false);
  
  if (autoEnd) {
    setCallEnded(true);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }

  if (sessionTimeoutRef.current) {
    clearTimeout(sessionTimeoutRef.current);
  }
  if (activityTimeoutRef.current) {
    clearTimeout(activityTimeoutRef.current);
  }

  stopRecording();
  audioService.current.stopAllAudio();
  
  // Only save session data (not journal)
  await saveCompleteConversation();

  setIsConnected(false);
  setConnectionStatus('disconnected');
  setIsEviSpeaking(false);
  setIsPlaying(false);

  if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
    wsRef.current.close(1000, 'Session paused');
  }

  setTimeout(async () => {
    console.log('Processing session end...');
    
    setTakingNoteMessage(false);
    setJournalButtonClicked(false);

    // REMOVE ALL AUTO-JOURNAL GENERATION
    // If user requested journal during call, just show them the button to generate it
    if (journalRequested && conversation.length > 2) {
      setShowViewJournalButton(true);
      setSuccessMessage('Call ended. Click "Generate Journal" to create your reflection.');
      setTimeout(() => setSuccessMessage(''), 4000);
      setJournalRequested(false);
    }
    
    // NO auto-save of journal entries

    // Show feedback popup if conditions are met
    if (shouldShowFeedbackAfterCall()) {
      console.log('Showing feedback popup after call end');
      showFeedbackAfterCall();
    }
    
  }, 500);
};

// Prevent other modals from opening when feedback is visible
const canOpenModal = () => {
  return !showFeedbackPopup;
};

// NEW: Handle reminder snoozing
const handleReminderSnooze = (minutes) => {
  if (!currentReminder) return;
  
  try {
    reminderService.setReminder(`in ${minutes} minutes`, currentReminder.message);
    console.log(`Reminder snoozed for ${minutes} minutes`);
    
    addMessageToConversation({
      type: 'system',
      content: `⏰ Reminder snoozed for ${minutes} minutes`,
      timestamp: new Date()
    });
    
  } catch (error) {
    console.error('Failed to snooze reminder:', error);
  }
};

// NEW: Handle reminder cancellation
const handleReminderCancel = (reminderId) => {
  const success = reminderService.cancelReminder(reminderId);
  if (success) {
    addMessageToConversation({
      type: 'system',
      content: '🗑️ Reminder cancelled',
      timestamp: new Date()
    });
  }
};

// Updated download journal function to include header
const downloadJournal = () => {
  const markdown = ExportService.generateMarkdown(
    conversation, 
    conversationSummary, 
    emotionalInsights, 
    summaryHeader // Pass header to the export service
  );
  const filename = `voice-journal-${new Date().toISOString().split('T')[0]}.md`;
  ExportService.downloadAsFile(markdown, filename, 'text/markdown');
  setSuccessMessage('Journal downloaded successfully!');
  setTimeout(() => setSuccessMessage(''), 1000);
};

// Add this useEffect to handle reminder notifications with proper error handling:
useEffect(() => {
  // Only proceed if reminderService exists and has the required methods
  if (!reminderService || typeof reminderService.checkTriggeredReminders !== 'function') {
    console.warn('ReminderService not properly initialized or missing checkTriggeredReminders method');
    return;
  }
  
  // Set up reminder notification handler
  const handleReminderTriggered = (reminder) => {
    console.log('Reminder triggered:', reminder);
    
    setCurrentReminder(reminder);
    setShowReminderTriggeredModal(true);
    
    // Add to conversation if session is active
    if (sessionActive) {
      addMessageToConversation({
        type: 'system',
        content: `🔔 Reminder: ${reminder.message}`,
        timestamp: new Date()
      });
    }
    
    // 🔥 REMOVED: Pre-response sound for notifications
    // If you want a notification sound, you could play startup sound or create a new notification sound method
  };
  
  // Check for triggered reminders every 30 seconds
  const reminderCheckInterval = setInterval(() => {
    try {
      if (reminderService && typeof reminderService.checkTriggeredReminders === 'function') {
        const triggered = reminderService.checkTriggeredReminders();
        if (Array.isArray(triggered)) {
          triggered.forEach(handleReminderTriggered);
        }
        
        if (typeof reminderService.getActiveReminders === 'function') {
          setActiveReminders(reminderService.getActiveReminders());
        }
      }
    } catch (error) {
      console.error('Error checking reminders:', error);
    }
  }, 30000);
  
  try {
    if (typeof reminderService.getActiveReminders === 'function') {
      setActiveReminders(reminderService.getActiveReminders());
    }
  } catch (error) {
    console.error('Error getting initial active reminders:', error);
  }
  
  return () => {
    clearInterval(reminderCheckInterval);
  };
}, [reminderService, sessionActive, soundEnabled]);

const checkForReminderRequest = (userText) => {
  if (!userText || !reminderService || typeof reminderService.setReminder !== 'function') {
    console.warn('Cannot process reminder request - reminderService not available');
    return false;
  }
  
  // Clean and log the input for debugging
  const cleanText = userText.toLowerCase().trim();
  console.log('🎤 Checking voice input for reminders:', cleanText);
  
  // More flexible reminder patterns for natural speech
  const reminderPatterns = [
    /remind me (?:to )?(.+?) (?:in|at) (.+)/i,
    /set (?:a )?reminder (?:to )?(.+?) (?:for|in|at) (.+)/i,
    /(?:can you )?remind me (?:to )?(.+?) (?:in|at) (.+)/i,
    /I need (?:a )?reminder (?:to )?(.+?) (?:in|at) (.+)/i,
    /reminder (?:to )?(.+?) (?:in|at) (.+)/i
  ];
  
  for (const pattern of reminderPatterns) {
    const match = userText.match(pattern);
    if (match) {
      const message = match[1].trim();
      const timeStr = match[2].trim();
      
      try {
        const reminder = reminderService.setReminder(timeStr, message);
        if (reminder) {
          console.log('🎤 Voice reminder created:', reminder);
          
          // CRITICAL: Update ALL the state variables that might affect the nav
          setCurrentReminder(reminder);
          setShowReminderSetModal(true);
          setReminderRequested(true);
          
          // 🔥 THIS IS THE KEY PART - Force update the activeReminders state
          // Make sure this matches what your Glass Nav is reading from
          if (typeof reminderService.getActiveReminders === 'function') {
            const updatedReminders = reminderService.getActiveReminders();
            console.log('📊 Updated active reminders after voice:', updatedReminders);
            setActiveReminders(updatedReminders); // ← Make sure this line exists!
          }
          
          // Add confirmation to conversation
          addMessageToConversation({
            type: 'system',
            content: `⏰ Voice reminder set: "${message}" for ${reminder.scheduledTime.toLocaleString()}`,
            timestamp: new Date()
          });
          
          console.log('✅ Voice reminder set successfully, activeReminders updated');
          return true;
        }
      } catch (error) {
        console.error('Failed to set voice reminder:', error);
        addMessageToConversation({
          type: 'system',
          content: `❌ Sorry, I couldn't set that reminder. Please try a different time format.`,
          timestamp: new Date()
        });
      }
      break;
    }
  }
  
  return false;
};

// Typing animations
const typeTextRealistic = (text, setter, speed = 50, onComplete) => {
  if (!text) return;

  let currentIndex = 0;
  const words = text.split(' ');
  let currentText = '';

  const typeNextWord = () => {
    if (currentIndex >= words.length) {
      setter(text);
      if (onComplete) onComplete();
      return;
    }

    const word = words[currentIndex];
    const isLastWord = currentIndex === words.length - 1;
    
    let charIndex = 0;
    const typeCharacter = () => {
      if (charIndex <= word.length) {
        const partialWord = word.substring(0, charIndex);
        const displayText = currentText + partialWord;
        setter(displayText);
        charIndex++;
        
        let charSpeed = speed;
        if (word[charIndex - 1] === ',' || word[charIndex - 1] === '.') {
          charSpeed = speed * 1;
        } else if (word[charIndex - 1] === ' ') {
          charSpeed = speed * 1;
        }
        
        const timeout = setTimeout(typeCharacter, charSpeed);
        setTypingTimeouts(prev => [...prev, timeout]);
      } else {
        currentText += word + (isLastWord ? '' : ' ');
        currentIndex++;
        
        const timeout = setTimeout(typeNextWord, speed * 2);
        setTypingTimeouts(prev => [...prev, timeout]);
      }
    };
    
    typeCharacter();
  };

  typeNextWord();
};

const typeHeaderText = (headerText, setter, onComplete) => {
  if (!headerText) return;

  let currentIndex = 0;
  
  const typeNextChar = () => {
    if (currentIndex >= headerText.length) {
      setter(headerText);
      setTimeout(() => {
        const headerElements = document.querySelectorAll('.summary-header ');
        headerElements.forEach(el => el.classList.add('typing-complete'));
      }, 10);
      if (onComplete) onComplete();
      return;
    }

    const char = headerText[currentIndex];
    const displayText = headerText.substring(0, currentIndex + 1);
    setter(displayText);
    currentIndex++;
    
    let speed = 2;
    if (char === ' ') speed = 5;
    
    const timeout = setTimeout(typeNextChar, speed);
    setTypingTimeouts(prev => [...prev, timeout]);
  };

  typeNextChar();
};

// Updated handleJournalNavClick to work with new flow
const handleJournalNavClick = () => {
  if (!canOpenModal()) return;
  
  console.log('Manual journal generation requested by user');
  
  if (Array.isArray(conversation) && conversation.length > 0) {
    if (sessionActive || isRecording) {
      // During call - just set flag for later
      setJournalRequested(true);
      setJournalButtonClicked(true);
      setTakingNoteMessage(true);
      setSuccessMessage('Journal noted! Generate it after your call ends.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } else {
      // After call - generate immediately since user clicked
      if (conversationSummary || emotionalInsights) {
        setShowSummary(true);
        setActiveTab('journal');
        setShowViewJournalButton(false);
      } else {
        setShowSummary(true);
        setActiveTab('journal');
        generateConversationSummary(conversation, true);
        setShowViewJournalButton(false);
      }
    }
  } else {
    if (sessionActive || isRecording) {
      setJournalRequested(true);
      setJournalButtonClicked(true);
      setTakingNoteMessage(true);
      setSuccessMessage('Journal noted! Generate it after your call ends.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } else {
      setError('No conversation to create a journal from');
      setTimeout(() => setError(''), 3000);
    }
  }
};


const navigateToJournal = () => {
  navigate('/journal');
};

const StartFreshButton = () => (
  <button
    className="start-fresh-btn"
    onClick={handleStartOver}
    disabled={isInitializing}
    title="Clear conversation and start fresh"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
    </svg>
    {isInitializing ? 'Clearing...' : 'Start Fresh'}
  </button>
);

const stopListening = () => {
  stopRecording();
  endSession(false);
  setTakingNoteMessage(false);
};

const getVoiceStyles = () => {
  if (!currentVoice || !currentVoice.color) return {};
  
  // Ensure color is a string and has the # prefix
  const color = currentVoice.color;
  if (typeof color !== 'string') return {};
  
  // Remove # if present, then convert to RGB
  const hexColor = color.startsWith('#') ? color.slice(1) : color;
  
  // Validate hex format (should be 6 characters)
  if (hexColor.length !== 6) return {};
  
  try {
    const rgb = hexColor.match(/.{2}/g).map(hex => parseInt(hex, 16));
    
    return {
      '--voice-color': currentVoice.color,
      '--voice-color-rgb': rgb.join(', ')
    };
  } catch (error) {
    console.warn('Failed to parse voice color:', currentVoice.color, error);
    return {};
  }
};

// Initialize AudioService with state callback
useEffect(() => {
  // Set up the callback to update React state when AudioService state changes
  audioService.current.setStateChangeCallback((audioStates) => {
    setStartupSoundPlaying(audioStates.startupSoundPlaying);
    setPreResponseSoundPlaying(audioStates.preResponseSoundPlaying);
    setIsPlaying(audioStates.isPlaying);
    setSoundEnabled(audioStates.soundEnabled);
  });

  // Initialize audio files
  audioService.current.initializeAllAudio();

  return () => {
    audioService.current.cleanup();
  };
}, []);

// 🔥 NEW: Export conversation history from Firestore
const handleExportConversations = async () => {
  try {
    if (!isStorageInitialized || !firestoreStorage.currentUser) {
      setError('Please wait for initialization or sign in');
      return;
    }
    
    await firestoreStorage.exportUserData();
    setSuccessMessage('📁 Conversation history exported successfully!');
    setTimeout(() => setSuccessMessage(''), 3000);
  } catch (error) {
    console.error('Export failed:', error);
    setError('Failed to export conversation history');
    setTimeout(() => setError(''), 3000);
  }
};

// 🔥 NEW: Reset all conversation data (with Firestore warning)
const handleResetAllData = async () => {
  if (window.confirm('⚠️ This will delete ALL conversation history from Firestore and reset your account. This cannot be undone. Are you sure?')) {
    try {
      if (!isStorageInitialized || !firestoreStorage.currentUser) {
        setError('Please wait for initialization or sign in');
        return;
      }
      
      // Note: You might want to implement a clearAllData method in FirestorePersistentStorageService
      // For now, we'll just reset the local state and clear current session
      await firestoreStorage.updateUserData({
        currentChatGroupId: null,
        currentChatId: null,
        totalSessions: 0,
        'stats.totalConversations': 0,
        'stats.totalMessages': 0,
        'stats.firstCallCompleted': false
      });
      
      // Reset component state
      setConversation([]);
      setConversationSummary('');
      setEmotionalInsights('');
      setSummaryHeader('');
      setCurrentChatGroupId(null);
      setCurrentChatId(null);
      setCurrentSessionId(null);
      
      await updateSessionStats();
      
      setSuccessMessage('🧹 Session data reset. Conversations preserved in Firestore.');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Reset failed:', error);
      setError('Failed to reset data');
      setTimeout(() => setError(''), 3000);
    }
  }
};
const CallControls = () => {
  const isExpired = isTimerExpired();
  
  return (
    <div className="call-controls">
      <button
        className={`listen-btn ${isExpired ? 'disabled' : ''}`}
        onClick={startListening}
        disabled={isExpired || isInitializing}
        title={isExpired ? 'Trial time exceeded' : 'Start conversation'}
      >
        {isExpired ? '⏰ Trial Ended' : isConnected ? '🎙️ Listening...' : '🎙️ Start Call'}
      </button>
      
      {isExpired && (
        <div className="trial-exceeded-notice">
          <p>Your 20-minute trial has ended</p> {/* Changed from "5-minute" to "20-minute" */}
          <button onClick={() => window.location.reload()}>
            Start New Trial
          </button>
        </div>
      )}
    </div>
  );
};

// 8. UPDATE: Add CSS for trial exceeded states
const trialExceededStyles = `
.timer-display.expired {
  background: rgba(255, 0, 0, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ff0000;
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.listen-btn.disabled {
  background: #666 !important;
  cursor: not-allowed !important;
  opacity: 0.5;
}

.trial-exceeded-notice {
  text-align: center;
  padding: 15px;
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid #ff4444;
  border-radius: 8px;
  margin-top: 10px;
}

.trial-exceeded-notice p {
  color: #ff4444;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.trial-exceeded-notice .support-message {
  font-size: 12px;
  font-weight: normal;
  color: #666;
  margin: 0;
}
`;

// 9. UPDATE: Add style injection
useEffect(() => {
  const styleId = 'trial-exceeded-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = trialExceededStyles;
    document.head.appendChild(style);
  }
}, []);

// 🔥 NEW: Display session stats from Firestore
const renderSessionStats = () => {
  if (!sessionStats || !persistentUserId) return null;
  
  return (
    <div className="session-stats" style={{ 
      position: 'absolute', 
      bottom: '10px', 
      left: '10px', 
      padding: '8px', 
      background: 'rgba(0,0,0,0.7)', 
      borderRadius: '8px', 
      fontSize: '11px', 
      color: 'white',
      fontFamily: 'monospace',
      zIndex: 1000
    }}>
      <div>Sessions: {sessionStats.totalSessions} | Messages: {sessionStats.totalMessages}</div>
      <div>User: {persistentUserId.slice(-8)}</div>
      {sessionStats.averageSessionDuration && (
        <div>Avg Duration: {Math.round(sessionStats.averageSessionDuration / 1000)}s</div>
      )}
      <div>Firestore: ✅</div>
    </div>
  );
};

const generateCircularDots = () => {
  const dots = [];
  const centerX = 100;
  const centerY = 100;
  
  const rings = [
    { radius: 20, dotSize: 6.5, dotCount: 7, isEdge: false },
    { radius: 35, dotSize: 5, dotCount: 12, isEdge: false },
    { radius: 50, dotSize: 4, dotCount: 16, isEdge: false },
    { radius: 65, dotSize: 4, dotCount: 20, isEdge: false },
    { radius: 80, dotSize: 3, dotCount: 24, isEdge: true },
    { radius: 90, dotSize: 1, dotCount: 28, isEdge: true }
  ];
  
  rings.forEach((ring, ringIndex) => {
    for (let i = 0; i < ring.dotCount; i++) {
      const angle = (i / ring.dotCount) * 2 * Math.PI;
      const x = centerX + ring.radius * Math.cos(angle);
      const y = centerY + ring.radius * Math.sin(angle);
      
      const waveDelay = (i / ring.dotCount) * 2 + (ringIndex * 0.3);
      const spreadDistance = ring.isEdge ? 
        Math.random() * 15 + 5 : 
        Math.random() * 8 + 2;
      
      dots.push(
        <div
          key={`${ringIndex}-${i}`}
          className={ring.isEdge ? 'circle-dot edge' : 'circle-dot-alex'}
          style={{
            width: ring.dotSize + 'px',
            height: ring.dotSize + 'px',
            left: (x - ring.dotSize / 2) + 'px',
            top: (y - ring.dotSize / 2) + 'px',
            animationDelay: waveDelay + 's',
            '--spread-distance': spreadDistance + 'px'
          }}
        />
      );
    }
  });
  
  dots.push(
    <div
      key="center"
      className="circle-dot-alex"
      style={{
        width: '10px',
        height: '10px',
        left: (centerX - 5) + 'px',
        top: (centerY - 5) + 'px',
        animationDelay: '0s',
        '--spread-distance': '3px'
      }}
    />
  );
  
  return dots;
};

// UseEffects for typing animations
useEffect(() => {
  if (summaryHeader && !isGeneratingSummary && displayedHeader !== summaryHeader) {
    typeHeaderText(summaryHeader, setDisplayedHeader, () => {
      if (conversationSummary && displayedSummary !== conversationSummary) {
        const timeout = setTimeout(() => {
          typeTextRealistic(conversationSummary, setDisplayedSummary, 10);
        }, 10);
        setTypingTimeouts(prev => [...prev, timeout]);
      }
    });
  }
}, [summaryHeader, isGeneratingSummary]);

useEffect(() => {
  if (emotionalInsights && !isGeneratingSummary && displayedInsights !== emotionalInsights) {
    const summaryLength = conversationSummary ? conversationSummary.length : 0;
    const headerLength = summaryHeader ? summaryHeader.length : 0;
    
    const estimatedHeaderTime = headerLength * 20 + 50;
    const estimatedSummaryTime = summaryLength * 5;
    const totalDelay = estimatedHeaderTime + estimatedSummaryTime + 20;
    
    const timeout = setTimeout(() => {
      typeTextRealistic(emotionalInsights, setDisplayedInsights, 5);
    }, totalDelay);
    
    setTypingTimeouts(prev => [...prev, timeout]);
  }
}, [emotionalInsights, isGeneratingSummary, conversationSummary, summaryHeader]);

useEffect(() => {
  if (showResponse && response) {
    const timeout = setTimeout(() => {
      setShowResponse(false);
      setResponse('');
    }, 4000);

    return () => clearTimeout(timeout);
  }
}, [response, showResponse]);

useEffect(() => {
  if (!showSummary) {
    setDisplayedSummary('');
    setDisplayedInsights('');
    setDisplayedHeader('');
    setEmmaLoadingPhase('initial');
    setEmmaLoadingProgress(0);
    typingTimeouts.forEach(timeout => clearTimeout(timeout));
    setTypingTimeouts([]);
  }
}, [showSummary]);

useEffect(() => {
  return () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };
}, []);

// 🔥 NEW: Show authentication warning if user is not signed in
if (!auth.currentUser && !isStorageInitialized) {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-spinner-large">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="loading-text">
          <h3>Initializing Preptune</h3>
          <p>Setting up your voice conversation experience...</p>
        </div>
      </div>
    </div>
  );
}


return (
  <div className="hume-evi-interface" style={getVoiceStyles()}>
    <MicPermissionDialog />
      {/* 🔥 ALWAYS SHOW LOADING SCREEN FIRST */}
      {isInitialLoading && (
        <LoadingScreen currentVoice={currentVoice} />
      )}
<TimerDisplay></TimerDisplay>
    {/* 🔥 NEW USER FLOW - Voice selection immediately */}
    {isAppReady && userFlow === 'new' && showVoiceSelection && (
      <VoiceSelectionModal
        isVisible={true}
        onVoiceSelected={handleVoiceSelected}
        currentVoice={currentVoice}
        voicePreferenceService={voicePreferenceService}
      />
    )}

    {/* 🔥 GUIDE FOR NEW USERS - After voice selection */}
    {isAppReady && userFlow === 'new' && !showVoiceSelection && showFirstTimeGuide && (
      <FirstTimeUserGuide
        isVisible={true}
        currentVoice={currentVoice}
        onComplete={handleGuideComplete}
        onStartFirstCall={handleStartFirstCall}
      />
    )}

    {/* 🔥 RETURNING USER GUIDE - If they didn't complete it before */}
    {isAppReady && userFlow === 'returning' && showFirstTimeGuide && (
      <FirstTimeUserGuide
        isVisible={true}
        currentVoice={currentVoice}
        onComplete={handleGuideComplete}
        onStartFirstCall={handleStartFirstCall}
      />
    )}

    {/* 🔥 MAIN APP - Only show when ready and no modals */}
    {isAppReady && 
     userFlow !== 'error' && 
     !showVoiceSelection && 
(
      <>
        {/* Reminder Modals */}
        <ReminderSetModal
          reminder={currentReminder}
          isVisible={showReminderSetModal}
          onClose={() => {
            setShowReminderSetModal(false);
            setCurrentReminder(null);
          }}
        />
        
        <ReminderTriggeredModal
          reminder={currentReminder}
          isVisible={showReminderTriggeredModal}
          onClose={() => {
            setShowReminderTriggeredModal(false);
            setCurrentReminder(null);
          }}
          onSnooze={handleReminderSnooze}
        />

        <FeedbackPopup
  isVisible={showFeedbackPopup}
  onClose={() => setShowFeedbackPopup(false)}
  onSubmit={handleFeedbackSubmit}
  onSkip={handleFeedbackSkip}
  currentVoice={currentVoice}
/>

        <VoiceIndicator />
        
        <div className="quiet-one-container">
          {/* Main Content Area */}
          <div className="main-content">
            {/* Top Status Bar */}
            <div className="top-status-bar">
              <div className="status-left">
                {currentEmotion && (
                  <div className="emotion-indicator">
                    <span className="emotion-text">{currentEmotion}</span>
                  </div>
                )}
                {sessionActive && (
                  <div className="session-status">
                    <span>Session: {sessionStartTime ? Math.floor((Date.now() - sessionStartTime.getTime()) / 1000) : 0}s</span>
                  </div>
                )}
              </div>
            </div>

            <div className='ai-alex-buddy-container'>
              {/* Central AI Buddy */}
              <div
                className={`ai-buddy ${isRecording && !isEviSpeaking ? 'listening' : ''}`}
                onClick={isRecording ? stopListening : startListening}
              >
                <div className={getBuddyClasses()}>
                  <div className="wave-animation"></div>
                  <div className="buddy-inner">
                    <div className="buddy-core-alex"></div>
                  </div>
                </div>

                {/* Circular dots pattern for listening */}
                {isRecording && !isEviSpeaking && (
                  <div className="dots-circle">
                    {generateCircularDots()}
                  </div>
                )}

                {/* Speaking dots */}
                <div className={`dots-alex-container ${isEviSpeaking ? 'show' : ''}`}>
                  <div className="dot alex dot-1"></div>
                  <div className="dot alex dot-2"></div>
                  <div className="dot alex dot-3"></div>
                  <div className="dot alex dot-4"></div>
                </div>

                {/* Status indicators */}
                {!isConnected && !startupSoundPlaying && (
                  <div className="status-indicator">
                    <div className="connection-dot disconnected"></div>
                    <span>Ready to chat?</span>
                  </div>
                )}

                {/* Calling indicator */}
                {startupSoundPlaying && (
                  <div className="status-indicator calling">
                    <div className="connection-dot calling-dot"></div>
                    <span>Calling</span>
                  </div>
                )}
              </div>
            </div>

            {/* Summary Panel */}
            {showSummary && (
              <div className="search-dropdown-overlay">
                <div className="search-dropdown">
                  {/* Tab Navigation */}
                  <div className="tab-navigation">
                    <button
                      className={`tab-button ${activeTab === 'journal' ? 'active' : ''}`}
                      onClick={() => setActiveTab('journal')}
                    >
                      <div className="ai-summary-icon">
                        {activeTab === 'user' ? (
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z" fill="white" fillRule="evenodd" clipRule="evenodd"/>
                          </svg>
                        ) : activeTab === 'reminders' ? (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5.365V3m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593-.399 1.292-1.867 1.292H6.867C5.399 18 5 17.301 5 16.708c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 12 5.365Z"/>
                          </svg>
                        ) : isGeneratingSummary ? (
                          <div className="loading-spinner"></div>
                        ) : (
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z" fill="white" fillRule="evenodd" clipRule="evenodd"/>
                          </svg>
                        )}
                      </div>
                      Journal Recap
                    </button>
                    
                    <button
                      className={`tab-button ${activeTab === 'user' ? 'active' : ''}`}
                      onClick={() => setActiveTab('user')}
                    >
                      <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                        <path fillRule="evenodd" d="M17 10v1.126c.367.095.714.24 1.032.428l.796-.797 1.415 1.415-.797.796c.188.318.333.665.428 1.032H21v2h-1.126c-.095.367-.24.714-.428 1.032l.797.796-1.415 1.415-.796-.797a3.979 3.979 0 0 1-1.032.428V20h-2v-1.126a3.977 3.977 0 0 1-1.032-.428l-.796.797-1.415-1.415.797-.796A3.975 3.975 0 0 1 12.126 16H11v-2h1.126c.095-.367.24-.714.428-1.032l-.797-.796 1.415-1.415.796.797A3.977 3.977 0 0 1 15 11.126V10h2Zm.406 3.578.016.016c.354.358.574.85.578 1.392v.028a2 2 0 0 1-3.409 1.406l-.01-.012a2 2 0 0 1 2.826-2.83ZM5 8a4 4 0 1 1 7.938.703 7.029 7.029 0 0 0-3.235 3.235A4 4 0 0 1 5 8Zm4.29 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h6.101A6.979 6.979 0 0 1 9 15c0-.695.101-1.366.29-2Z" clipRule="evenodd"/>
                      </svg>
                      User Info
                    </button>
                    <button
                      className="dropdown-close"
                      onClick={() => setShowSummary(false)}
                    >
                      <ChevronUp size={16} />
                    </button>
                  </div>

                  <div className="dropdown-content">
                    {/* User ID Tab Content */}
{/* User ID Tab Content */}
{activeTab === 'user' && (
  <div className="user-content">
{activeTab === 'user' && (
  <UserInfoTabContent
    persistentUserId={persistentUserId}
    currentVoice={currentVoice}
    isIdVisible={isIdVisible}
    setIsIdVisible={setIsIdVisible}
    copied={copied}
    setCopied={setCopied}
    firestoreStorage={firestoreStorage}
    isStorageInitialized={isStorageInitialized}
    changeVoice={changeVoice}
    handleStartOver={handleStartOver}
    handleSignOut={handleSignOut}
    setShowSummary={setShowSummary}
    timeRemaining={timeRemaining}  // Add this line
    isRecording={isRecording}      // Add this line
    callEnded={callEnded}          // Add this line
  />
)}
  </div>
)}

                    {/* Journal Tab Content */}
                    {activeTab === 'journal' && (
                      <>
                        {/* Loading State */}
                        {(isGeneratingSummary || (journalRequested && sessionActive)) && (
                          <div className="dropdown-item">
                            <div className="item-text">
                              <div className="item-description">
                                {sessionActive ? 'Taking notes... Summary will be ready when conversation ends' : 'Preptune is summarizing...'}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Summary Section with Dynamic Header */}
                        {conversationSummary && !isGeneratingSummary && (
                          <div className="dropdown-item">
                            <div className="item-text">
                              <div className="item-title">
                                <span className="emma-typing-text" data-text={summaryHeader}>
                                  {displayedHeader}
                                </span>
                              </div>
                              <div className="item-description emma-typing-text" data-text={conversationSummary}>
                                {displayedSummary}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Emotional Insights Section */}
                        {emotionalInsights && !isGeneratingSummary && (
                          <div className="dropdown-item">
                            <div className="item-icon">
                              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.50203 5.49797 8.125 7.5 8.125C9.50203 8.125 11.125 6.50203 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM1 7.5C0.723858 7.5 0.5 7.72386 0.5 8C0.5 8.27614 0.723858 8.5 1 8.5H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H8C8.27614 14.5 8.5 14.2761 8.5 14V8.5H14C14.2761 8.5 14.5 8.27614 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5H8.5V2C8.5 1.72386 8.27614 1.5 8 1.5H7C6.72386 1.5 6.5 1.72386 6.5 2V7.5H1Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                              </svg>
                            </div>
                            <div className="item-text">
                              <div className="item-title">Emotional Insights</div>
                              <div className="item-description emma-typing-text" data-text={emotionalInsights}>
                                {displayedInsights}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Action Buttons */}
                        {!isGeneratingSummary && (conversationSummary || emotionalInsights) && (
                          <div className="dropdown-item summary-actions">
                            <div className="item-text">
                              <div className="item-title">Actions</div>
                              <div className="summary-buttons">
                                {!isManuallySaved ? (
                                  <button
                                    className="summary-btn primary"
                                    onClick={saveJournalEntry}
                                    disabled={isSaving}
                                  >
                                    {isSaving ? (
                                      <>
                                        <div className="loading-spinner-small"></div>
                                        <span>Saving...</span>
                                      </>
                                    ) : (
                                      <>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V5.50006C10 5.77622 10.2239 6.00006 10.5 6.00006C10.7761 6.00006 11 5.77622 11 5.50006V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM13.8536 6.14652C14.0488 6.34178 14.0488 6.65836 13.8536 6.85362L10.8536 9.85362C10.6583 10.0489 10.3417 10.0489 10.1464 9.85362L8.64645 8.35362C8.45118 8.15836 8.45118 7.84178 8.64645 7.64652C8.84171 7.45125 9.15829 7.45125 9.35355 7.64652L10.5 8.79297L13.1464 6.14652C13.3417 5.95125 13.6583 5.95125 13.8536 6.14652Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                                        </svg>
                                        <span>Save Journal</span>
                                      </>
                                    )}
                                  </button>
                                ) : (
                                  <>
                                    <div className="summary-btn success">
                                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                                      </svg>
                                      <span>Saved</span>
                                    </div>
                                    <button
                                      className="summary-btn primary"
                                      onClick={navigateToJournal}
                                    >
                                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                                      </svg>
                                      View
                                    </button>
                                  </>
                                )}
                                <button className="summary-btn secondary" onClick={downloadJournal}>
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                                  </svg>
                                  Download
                                </button>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Empty state when no content and not generating */}
                        {!isGeneratingSummary && !conversationSummary && !emotionalInsights && (
                          <div className="dropdown-item">
                            <div className="item-text">
                              <div className="item-title">No Content</div>
                              <div className="item-description">Start a conversation to generate your journal summary.</div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="conversation-area">
              {message && (
                <div className="message-input" style={{ opacity: message ? 1 : 0.7 }}>
                  {message}
                </div>
              )}

              {showResponse && (
                <div
                  className="response-container"
                  style={{
                    transform: `translateY(${showResponse ? '0' : '20px'})`,
                    opacity: showResponse ? 1 : 0
                  }}
                >
                  <p className="response-text">{response}</p>
                </div>
              )}
            </div>
          </div>
<ThreeNavGlass
  activeTab="home" // or whatever the current active tab should be
  onJournalClick={() => {
    // Handle journal navigation
    console.log('home clicked');
  }}
  onHomeClick={() => {
    // Handle home navigation
    console.log('chat-mdoe clicked');
  }}
/>
          <GlassNavigation
            // State props
            onShowGuide={() => setShowFirstTimeGuide(true)}
            activeTab={activeTab}
            isRecording={isRecording}
            callEnded={callEnded}
            timeRemaining={timeRemaining}
            takingNoteMessage={takingNoteMessage}
            journalButtonClicked={journalButtonClicked}
            isGeneratingSummary={isGeneratingSummary}
            soundEnabled={soundEnabled}
            activeReminders={activeReminders}
            watchingThreads={watchingThreads}
            sessionActive={sessionActive}
            showViewJournalButton={showViewJournalButton}
              conversationSummary={conversationSummary}
  displayedSummary={displayedSummary}
            // Handler props
            onStartCall={startListening}
            startListening={startListening}
            stopListening={stopListening}
            handleStartOver={handleStartOver}
            handleJournalNavClick={handleJournalNavClick}
            toggleSound={toggleSound}
            setActiveTab={setActiveTab}
            setShowSummary={setShowSummary}
            setShowViewJournalButton={setShowViewJournalButton}
            onStartFirstCall={handleStartFirstCall}
            onEndCall={stopListening}
          />
        </div>

        {/* Status Messages */}
        {startupSoundPlaying ? (
          <div className="subtitle"></div>
        ) : isEviSpeaking ? (
          <div className="subtitle">Talk to interrupt</div>
        ) : isRecording ? (
          <div className="subtitle">Preptune is Listening</div>
        ) : null}


<ThreeNavGlass
  activeTab="home" // or whatever the current active tab should be
  onJournalClick={() => {
    // Handle journal navigation
    console.log('home clicked');
  }}
  onHomeClick={() => {
    // Handle home navigation
    console.log('chat-mdoe clicked');
  }}
/>

      </>
    )}
  </div>
);

};
export default HumeEVIInterface;